<template>
<div class="planning-fc-wrapper" :class="{ 'pwgs-compacto': compacto, 'pwgs-vista-mes': esVistaMes }" :style="[difuminado, { width: anchoPlanning }]">
  <div v-if="overlayDiaVisible && (citasDiaHover.length || tituloDiaHover)"
  class="fc-overlay-panel"  @mouseenter="cancelarCerrarDia" @mouseleave="iniciarCerrarDia"
  :style="{ position:'fixed', top: overlayDiaY + 'px', left: overlayDiaX + 'px', zIndex: 9999, maxWidth:'320px', maxHeight:'60vh', overflowY:'auto' }">
  <b v-if="tituloDiaHover">{{ tituloDiaHover }}</b>
  <!-- Nueva cita en la franja (solo vista semanal) -->
        <div v-if="franjaTooltip" style="text-align:center;margin-bottom:4px">
        <button class="btn btn-primary btn-sm" style="font-size:0.75em;padding:2px 10px"
          @click.stop="nuevaCitaDesdeFranja()">Nueva cita</button>
      </div>
 <div v-for="(c, i) in citasDiaHover" :key="i"
        :style="{ marginTop:'3px', cursor: c.idservicio ? 'pointer' : 'default' }"
        @click="irAExpediente(c)"
        @mouseenter="mostrarSubTooltip(c, $event)"
        @mouseleave="ocultarSubTooltip()">
        <div style="display:flex;align-items:flex-start;gap:5px">
          <span :style="{ background: c.color, display:'inline-block', width:'10px', height:'10px', borderRadius:'2px', flex:'0 0 auto', border:'1px solid #0003', marginTop:'2px' }"></span>
          <span style="font-size:0.75em;min-width:0">
            <template v-if="c.descripcion">
              <b>{{ c.referencia }}</b> · <b>{{ c.operario }}</b><br>
              {{ c.horaIni }}-{{ c.horaFin }} · {{ c.direccion || c.titulo }}
            </template>
            <template v-else><b>{{ c.operario }}</b> · {{ c.horaIni }}-{{ c.horaFin }} · {{ c.titulo }}</template>
          </span>
        </div>
        <div v-if="c.idVisita" @click.stop
          style="display:flex;gap:2px;flex-wrap:wrap;margin:2px 0 1px 15px">
          <button title="Ir al servicio" class="tt-btn" @click="accionCita('irservicio', c)"><i class="fas fa-paste"></i></button>
          <button v-if="puedeEliminarCita(c.finalizada, c.color)" title="Eliminar visita"
            class="tt-btn" style="color:#c00" @click="accionCita('eliminar', c)">
            <i class="fas fa-times"></i>
          </button>
          <button v-if="(c.color || '').toLowerCase() === '#ff4646'" title="Confirmar visita" class="tt-btn" @click="accionCita('confirmar', c)"><i class="fas fa-align-justify"></i></button>
          <button title="Mostrar Trabajos" class="tt-btn" @click="accionCita('trabajos', c)"><i class="far fa-plus-square"></i></button>
          <button title="Presupuesto" class="tt-btn" @click="accionCita('presupuesto', c)"><i class="far fa-folder-open"></i></button>
          <button title="Modificar visita" class="tt-btn" @click="accionCita('editar', c)"><i class="far fa-edit"></i></button>
          <button title="Chat" class="tt-btn" style="position:relative" @click="accionCita('chat', c)">
  <i class="far fa-comment-dots"></i>
  <span v-if="chatsPorVisita[c.idVisita] > 0"
    style="position:absolute;top:-6px;right:-6px;min-width:14px;height:14px;padding:0 3px;border-radius:7px;background:#dc3545;color:#fff;font-size:0.8em;line-height:14px;text-align:center;font-weight:bold">
    {{ chatsPorVisita[c.idVisita] }}
  </span>
</button>
          <button title="Finalizar visita" class="tt-btn" @click="accionCita('finalizar', c)"><i class="fas fa-check"></i></button>
          <div style="position:relative;display:inline-block">
            <button title="Envíos" class="tt-btn" @click="toggleEnvios(i, $event)"><i class="fas fa-share-square"></i></button>
            <ul v-if="envioAbierto === i"
              :style="{ position: 'fixed', left: envioX + 'px', top: envioY + 'px', background: '#fff', border: '1px solid #ccc', borderRadius: '4px', listStyle: 'none', padding: '4px 0', margin: 0, zIndex: 10002, minWidth: '160px', boxShadow: '0 2px 8px rgba(0,0,0,0.2)', fontSize: '0.8em' }">
              <li class="tt-dd" @click="accionCita('fichaemail', c)">Enviar ficha email</li>
              <li class="tt-dd" style="border-top:1px solid #eee" @click="accionCita('smsoperario', c)">SMS al operario</li>
              <li class="tt-dd" @click="accionCita('smsasegurado', c)">SMS al asegurado</li>
              <li class="tt-dd" @click="accionCita('ste', c)">Firma STE email</li>
            </ul>
          </div>
          <button title="Parte genérico" class="tt-btn" @click="accionCita('parte', c)">
            <i :class="c.tieneFirma === '1' ? 'fas fa-file-signature' : 'far fa-file'"></i>
          </button>
        </div>
      </div>
</div>
    <div v-if="spinner" class="spinner"></div>

    <div v-if="ocultar" class="alert alert-danger" role="alert">
      <h4>No hay operarios disponibles con los filtros seleccionados</h4>
    </div>

    <div v-show="!ocultar">
      <FullCalendar ref="fullCalendar" :options="calendarOptions" />

    </div>
 <OverlayPanel :dismissable="true" ref="calenddos">
  <Calendar showOtherMonths selectOtherMonths v-model="fechacalddos" inline />
</OverlayPanel>
    <!-- OVERLAY EVENTO NORMAL -->
    <div v-if="overlayVisible && eventoHover"
      class="fc-overlay-panel"
      :style="{ position: 'fixed', top: overlayY + 'px', left: overlayX + 'px', zIndex: 9999 }"
      @mouseenter="cancelarCerrarOverlay"
      @mouseleave="iniciarCerrarOverlay">
      <b>{{ nombreevento }}</b>
      <span v-if="distanciaevento && distanciaevento > 0" :style="estiloDistancia">Dist: {{ distanciaevento }}&nbsp;Km</span>      <p v-html="descripcionevento"></p>
    </div>

    <!-- OVERLAY BLOQUEADO/VACACIONES -->
    <div v-if="overlayBloqVisible"
      class="fc-overlay-panel"
      :style="{ position: 'fixed', top: overlayBloqY + 'px', left: overlayBloqX + 'px', zIndex: 9999 }">
      <p>{{ descripcionbloq }}</p>
    </div>
      <!-- SUBTOOLTIP: especialidad + descripción de la cita -->
    <div v-if="subTooltipVisible"
      class="fc-overlay-panel"
      :style="{ position: 'fixed', top: subTooltipY + 'px', left: subTooltipX + 'px', zIndex: 10001, maxWidth: '300px' }">
      <p style="font-size:0.8em;margin:0" v-html="subTooltipHtml"></p>
    </div>
    <!-- DIALOG DETALLE EVENTO -->
  <Dialog ref="dialog1" :blockScroll="false" :class="{ 'dialogo-oculto': detalleOculto }" :dismissableMask="true" @hide="recargar(); restaurarScroll()" :draggable="false" v-model:visible="visible"
    modal :header="titulo" :style="{ width: altura }" @show="onShowPanel">
      <p v-html="decode_utf8(infoevento)"></p>
      <servicio-datos-visitas-visita
      ref="visitaDatos"
        :planning="1" @cerrar="visible = false" :visita="eventoamostrar" :chatsvisita="chatsvisita" v-if="eventoamostrar"
        :colorbotondos="colorbotondos" :colorbotontres="colorbotontres" @recargar="recargar()"
        :colorbotoncuatro="colorbotoncuatro" :colorboton="colorboton" :servicio="servicio" :id="id" />
      <div class="row" v-if="editar" style="background:#c7f08b61">
        <div class="col-md-3">
          <div class="form-group">
            <label>{{ $t('general.FechaInicio') }}</label><br>
            <Calendar v-model="fechainicioeditar" :stepMinute="10" showTime hourFormat="24" dateFormat="dd/mm/yy" />
            <div class="custom-control custom-checkbox"><br>
              <input v-model="nomodificar" class="custom-control-input" type="checkbox" id="nomodificar2g" true-value="1" false-value="0">
              <label for="nomodificar2g" class="custom-control-label">{{ $t('general.nomodificar') }}</label>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>{{ $t('general.fechafin') }}</label><br>
            <Calendar v-model="fechafineditar" showTime :stepMinute="10" dateFormat="dd/mm/yy" />
            <div class="custom-control custom-checkbox"><br>
              <input v-model="prioritaria" class="custom-control-input" type="checkbox" id="prioritaria2g" true-value="1" false-value="0">
              <label for="prioritaria2g" class="custom-control-label">{{ $t('general.prioritaria') }}</label>
            </div>
          </div><br><br>
          <Button @click="modificarVisita(eventoamostrar, fechainicioeditar, fechafineditar, infoevento, nomodificar, prioritaria)">
            {{ $t('general.guardar') }}
          </Button>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>{{ $t('general.descripcion') }}</label>
            <Textarea autoResize v-model="infoevento" class="descripcion" />
          </div>
        </div>
      </div>
      <div class="row" v-if="finalizar">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header bg-gray">
              <h3 class="card-title"><i class="fab fa-telegram-plane mr-2"></i>{{ $t('finalizarvisita') }}</h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <label>Trabajos realizados</label>
                  <textarea v-model="trabajosrealizadostexto" class="form-control" rows="10" />
                </div>
                <div class="col-md-6">
                  <label>Trabajos pendientes</label>
                  <textarea v-model="trabajospendientestexto" class="form-control" rows="10" />
                </div>
              </div>
              <div class="row">
                <div class="col-md-5"></div>
                <div class="col-md-2">
                  <button class="btn btn-success btn-block" @click="finVisita()" type="button">Finalizar Visita</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <planningcomunicaciones v-if="mostrarcomunicaciones && eventoamostrar"
        :id="eventoamostrar.visita.servicios_idservicios" :idvisita="eventoamostrar.visita.idvisitador" />
      <trabajosrealizadosoperarios v-if="eventoamostrar && trabajos"
        :operariosingular="operariosingular" :servicio="servicio" :totalrent="totalrent"
        :ocultarcliente="ocultarcliente" :ocultaroperario="ocultaroperario"
        :totalcliente="totalcliente" :totaloperario="totaloperario"
        :id="eventoamostrar.visita.servicios_idservicios" />
      <presupuestos v-if="presupuestos && eventoamostrar" :id="eventoamostrar.visita.servicios_idservicios" />
    </Dialog>

    <!-- DIALOG NUEVA VISITA -->
    <Dialog ref="dialog2" :blockScroll="false" @hide="onHideNuevaCita" draggable="false" v-model:visible="nevisible"
      :header="$t('general.nuevacita') + ' (' + new Date(eventoacrear).toLocaleDateString('es-ES') + ')'"
      :style="{ width: '45vw', height: '80vh' }">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group" v-if="modoEspecialidadPrimero">
            <label>{{ $t('general.especialidad') }}</label><br>
            <select style="width:100%" v-model="especialidadseleccionada" class="custom-select form-control-sm">
              <option value="">Seleccione especialidad</option>
              <option v-for="e in especialidadesdos" :key="e.id_especialidad" :value="e.id_especialidad">{{ e.nombre }}</option>
            </select>
          </div>
          <div class="form-group" v-else>
            <label>{{ $t('general.operario') }}</label><br>
            <select style="width:100%" v-model="operarioseleccionado" class="custom-select form-control form-control-sm">
              <option v-for="op in operariossplit" :key="op.id" :value="op.id">{{ op.label }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6" v-if="mostrarPlantillas">
          <div class="form-group">
            <label>Plantilla descripción</label><br>
            <select style="width:100%" v-model="plantilladescripcionseleccionada" class="custom-select form-control form-control-sm">
              <option value="">Seleccione una plantilla</option>
              <option v-for="pl in Object.keys(propiedadescalendariooper.plantillas_descripcion_visita || {})" :key="pl" :value="pl">{{ pl }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Visita a</label><br>
            <select style="width:100%" v-model="clienteseleccionado" class="custom-select form-control-sm">
              <option v-for="cliente in clientes" :key="cliente.idcliente" :value="cliente">{{ cliente.nombre }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Descripción visita</label><br>
            <Textarea placeholder="Descripción de la visita" style="width:100%" autoResize v-model="descripcionvisitas"></Textarea>
            <label><span v-if="descripcionvisitas">{{ descripcionvisitas.length }}</span> carácteres. Mínimo {{ descripcionminima }} Caracteres.</label><br>
            <div style="text-align:end">
              <button @click="agregarvisita()" class="btn btn-primary btn-sm">Añadir visita</button>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <table class="table table-sm">
            <tbody>
              <tr v-for="descr in clientedescripcion" :key="descr.cliente"><td>{{ descr.nombre }}</td></tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row" style="margin-bottom:20px;margin-top:10px">
        <div class="col-md-6">
           <div class="form-group" v-if="modoEspecialidadPrimero">
            <label>{{ $t('general.operario') }}</label><br>
            <select style="width:100%" v-model="operarioseleccionado" class="custom-select form-control form-control-sm">
              <option v-for="op in operariossplit" :key="op.id" :value="op.id"
                :style="op.preferente ? { background: '#f9cc98' } : {}">
                {{ op.label }}{{ op.carga !== undefined && op.carga !== null && op.carga !== '' ? ' (' + op.carga + '%)' : '' }}{{ op.preferente ? ' (preferente)' : '' }}
              </option>
            </select>
          </div>
          <div class="form-group" v-else>
            <label>{{ $t('general.especialidad') }}</label><br>
            <select style="width:100%" v-model="especialidadseleccionada" class="custom-select form-control-sm">
              <option value="">Seleccione especialidad</option>
              <option v-for="e in especialidadesdos" :key="e.id_especialidad" :value="e.id_especialidad">{{ e.nombre }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>{{ $t('general.FechaInicio') }}</label><br>
            <Calendar style="width:100%" v-model="fechainicio" showTime hourFormat="24" :stepMinute="10" dateFormat="dd/mm/yy" />
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>{{ $t('general.fechafin') }}</label><br>
            <Calendar style="width:100%" v-model="fechafin" showTime hourFormat="24" :stepMinute="10" dateFormat="dd/mm/yy" />
          </div>
        </div>
      </div>
      <div class="row">
        <div v-if="prestiacionesactivado" class="col-md-6">
          <div class="form-group">
            <label>Intervención IPAS</label><br>
            <select v-if="!servicio?.precita_ipas" style="width:100%" v-model="prestacionseleccionada" class="custom-select form-control-sm">
              <option value="">Seleccione intervención</option>
              <option v-for="p in prestaciones" :key="p.valor" :value="p.valor">{{ decode_utf8(p.texto) }}</option>
            </select>
            <div class="card card-warning" v-else style="padding:0px;">
                <div class="card-header" style="border-bottom-left-radius: 0.25rem; border-bottom-right-radius: 0.25rem;text-align: center;">
                    <h8>No est&aacute; permitido crear cita. Debe confirmar la precita de IPAS</h8>
                </div>
            </div>
          </div>
        </div>
        <div v-if="trabajosservactivado && especialidadseleccionada != ''" class="col-md-6">
          <div class="form-group">
            <label>Trabajos</label><br>
            <select style="width:100%" v-model="trabajoservseleccionado" class="custom-select form-control-sm">
              <option value="">Seleccione trabajo</option>
              <option v-for="t in trabajosserv" :key="t.id" :value="t.id">{{ t.nombre }}</option>
            </select>
          </div>
        </div>
        <div v-if="telefonosactivado" class="col-md-6">
          <div class="form-group">
            <label>Tlf del evento</label>
            <div v-for="(grupo, i) in gruposTelefonos" :key="i" class="mb-2">
              <div class="d-flex flex-wrap" style="gap: 1rem;">
                <div v-for="tlf in grupo.telefonos" :key="i + '_' + tlf.id" class="custom-control custom-radio custom-control-inline mr-0">
                  <input type="radio" class="custom-control-input" :id="'tlf_evento_' + i + '_' + tlf.id" :value="tlf.id" v-model="telefonoseleccionado">
                  <label class="custom-control-label font-weight-normal" :for="'tlf_evento_' + i + '_' + tlf.id" :title="tlf.descripcion">
                    {{ tlf.numero }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="margin:25px 0">
        <div class="col-md-4">
          <strong>Propiedades</strong>
          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input v-model="prioritaria" class="custom-control-input" type="checkbox" id="prioritaria3g" true-value="1" false-value="0">
              <label style="font-weight:normal" for="prioritaria3g" class="custom-control-label">{{ $t('general.prioritaria') }}</label>
            </div>
            <div class="custom-control custom-checkbox">
              <input v-model="nomodificar" class="custom-control-input" type="checkbox" id="nomodificar3g" true-value="1" false-value="0">
              <label style="font-weight:normal" for="nomodificar3g" class="custom-control-label">{{ $t('general.nomodificar') }}</label>
            </div>
            <div v-if="porconfimaractivado" class="custom-control custom-checkbox">
              <input v-model="confirmar_cita" class="custom-control-input" type="checkbox" id="confirmarcitag" true-value="1" false-value="">
              <label style="font-weight:normal" for="confirmarcitag" class="custom-control-label">Por confirmar</label>
            </div>
            <div v-if="medicionactivada" class="custom-control custom-checkbox">
              <input v-model="medicion" class="custom-control-input" type="checkbox" id="mediciong" true-value="1" false-value="0">
              <label style="font-weight:normal" for="mediciong" class="custom-control-label">Medición</label>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div v-if="documentosactivado && documentos.length > 0">
            <strong>Documentos rellenar operario</strong>
            <div v-for="doc in documentos" :key="doc.id" class="custom-control custom-checkbox">
              <input v-model="doc.activated" class="custom-control-input" type="checkbox" :id="'docg_'+doc.id" true-value="1" false-value="0">
              <label style="font-weight:normal" :for="'docg_'+doc.id" class="custom-control-label">{{ doc.nombre }}</label>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div v-if="gruposactivado && grupos.length > 0">
            <strong>Grupo campos rellenar operario</strong>
            <div v-for="grp in grupos" :key="grp.id" class="custom-control custom-checkbox">
              <input v-model="grp.activated" class="custom-control-input" type="checkbox" :id="'grpg_'+grp.id" true-value="1" false-value="0">
              <label style="font-weight:normal" :for="'grpg_'+grp.id" class="custom-control-label">{{ grp.nombre }}</label>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div v-if="presupuestosactivado && presupuestoss.length > 0">
            <strong>Presupuestos rellenar operario</strong>
            <div v-for="pr in presupuestoss" :key="pr.id" class="custom-control custom-checkbox">
              <input v-model="pr.activated" class="custom-control-input" type="checkbox" :id="'prg_'+pr.id" true-value="1" false-value="0">
              <label style="font-weight:normal" :for="'prg_'+pr.id" class="custom-control-label">{{ pr.nombre }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div v-if="equipos.length >= 1 && equiposactivado" class="col-md-6">
          <label>{{ $t('general.equiposareparar') }}</label><br>
          <MultiSelect v-model="equiposseleccionado" :options="equipos"
            optionValue="equipo.id_servicio_equipo" optionLabel="equipo.nombre_equipo"
            placeholder="Seleccione equipo" :maxSelectedLabels="3" style="width:100%" />
        </div>
        <div class="col-md-6" v-if="pedidosactivado && pedidos.length >= 1">
          <div class="form-group">
            <label>Pedido</label><br>
            <MultiSelect v-model="pedidosSeleccionados" :options="pedidos"
              optionValue="id" optionLabel="nombre"
              placeholder="Seleccione pedido" :maxSelectedLabels="3" style="width:100%" />
          </div>
        </div>
      </div>
      <div class="col-md-12" style="margin-top:25px">
        <div style="text-align:center">
          <button @click="nuevavisita(fechainicio, fechafin)" class="btn btn-primary btn-sm">Nueva cita</button>
        </div>
      </div>
    </Dialog>
    <!-- DIALOG CONFIRMACIÓN MOVER/REDIMENSIONAR -->
    <Dialog :blockScroll="false" header="¿Quieres modificar la cita?" draggable="false" :style="{ width: '25rem' }"
      @hide="onHideConfirmacion" v-model:visible="confirmacionvisible" modal>
      <div class="row" v-if="eventoamodificar && eventoamodificar.event">
        <div class="col-md-12 text-center">
          <h5><b>{{ eventoamodificar.event.title }}</b></h5>
          <b>Original:</b> {{ formatFecha(eventoamodificar.originalStart) }} hasta {{ formatHora(eventoamodificar.originalEnd) }}<br>
          <b>Nuevo:</b> {{ formatFecha(eventoamodificar.event.start) }} hasta {{ formatHora(eventoamodificar.event.end) }}
          <div v-if="eventoamodificar.nombreOperarioNuevo" style="margin-top:6px">
            <b>Operario:</b> {{ eventoamodificar.nombreOperarioNuevo }}
          </div>
        </div>
      </div>
      <div class="row mt-2" v-if="ipas && razones && razones.length > 0">
        <div class="col-12">
          <h3 style="margin-top:30px;text-align:center">Comunicación con IPAS</h3>
          <div class="form-group">
            <label>Razón:</label>
            <select v-model="razonipas" class="form-control">
              <option value="">--------</option>
              <option v-for="r in razones" :key="r.valor" :value="r.valor">{{ r.texto }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Sub-Razón:</label>
            <select :disabled="razonipas == ''" v-model="subrazonipas" class="form-control">
              <option value="">--------</option>
              <option v-for="s in subrazones" :key="s.valor" :value="s.valor">{{ s.texto }}</option>
            </select>
          </div>
          <div v-if="cancelacion" class="form-group">
            <label>Fecha y hora próximo contacto:</label>
            <Calendar :disabled="razonipas == ''" style="width:100%" dateFormat="dd/mm/yy" v-model="cancelacion" showTime hourFormat="24" />
          </div>
          <div class="form-group">
            <label>Motivo:</label>
            <textarea :disabled="razonipas == ''" class="form-control" v-model="motivo"></textarea>
          </div>
          <p>Si no se indica una razón solo se modificará la descripción en PWGS</p>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-3"></div>
        <div class="col-md-3">
          <button style="width:100%;background:green;border:0" @click="crearevento(eventoamodificar, tipoamodificar)" class="btn btn-primary btn-sm">Si</button>
        </div>
        <div class="col-md-3">
          <button style="width:100%;background:red;border:0" @click="onHideConfirmacion" class="btn btn-primary btn-sm">Cancelar</button>
        </div>
      </div>
    </Dialog>
    <!-- DIALOG CONFIRMAR CITA -->
    <Dialog :blockScroll="false" v-model:visible="citaconfirmar" :style="{ width: '35rem' }" header="Confirmacion de la cita" modal>
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <div class="form-group">
            <label>{{ $t('general.fechainicio') }}</label><br>
            <Calendar v-model="datoscitaconfirmar.fechacita" showTime hourFormat="24" :stepMinute="10" dateFormat="dd/mm/yy" />
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label>{{ $t('general.fechafin') }}</label><br>
            <Calendar v-model="datoscitaconfirmar.fechacitafin" showTime hourFormat="24" :stepMinute="10" dateFormat="dd/mm/yy" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4"></div>
        <div class="col-md-4">
          <Button @click="aprobarconfirmar()">Confirmar Cita</Button>
        </div>
      </div>
    </Dialog>
    <!-- DIALOG CONFIRMAR ELIMINAR VACACIONES/BLOQUEOS -->
    <Dialog :header="bloqueAEliminar?.tipo === 'VACACIONES' ? 'Eliminar vacaciones' : 'Eliminar bloqueo'"
    :blockScroll="false" @hide="onHideNuevaCita"
    v-model:visible="bloqueConfirmar" modal :style="{ width: '25rem' }" draggable="false">
      <p style="text-align:center">
        ¿Seguro que quieres eliminar este {{ bloqueAEliminar?.tipo === 'VACACIONES' ? 'periodo de vacaciones' : 'bloqueo' }}?
      </p>
      <p v-if="bloqueAEliminar" style="text-align:center;font-size:0.9em">
        {{ bloqueAEliminar.content }}
      </p>
      <div class="row mt-3">
        <div class="col-md-3"></div>
        <div class="col-md-3">
          <button style="width:100%;background:green;border:0" @click="eliminarBloque()" class="btn btn-primary btn-sm">Aceptar</button>
        </div>
        <div class="col-md-3">
          <button style="width:100%;background:red;border:0" @click="cancelarEliminarBloque" class="btn btn-primary btn-sm">Cancelar</button>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue3';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import scrollGridPlugin from '@fullcalendar/scrollgrid';
import OverlayPanel from 'primevue/overlaypanel';
//import Dropdown from 'primevue/dropdown';
import MultiSelect from 'primevue/multiselect';
import Dialog from 'primevue/dialog';
import Calendar from 'primevue/calendar';
import Textarea from 'primevue/textarea';
import Button from 'primevue/button';
import Presupuestos from '../servicios/presupuestos/presupuestos.vue';
import planningcomunicaciones from '../servicios/planning/planning_comunicaciones.vue';
import trabajosrealizadosoperarios from '../servicios/trabajosrealizados/TrabajosRealizadosOperario.vue';
import serviciodatosvisitasvisita from '../servicios/datos/visitas/visita_datos.vue';
import { PwgsApi } from '../../../services/PwgsApi';
// ── Título del planning sin "de" y con día de la semana ──
const capitalizar = s => s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
const aFecha = d => new Date(d.year, d.month, d.day);
const nombreMes = f => f.toLocaleDateString('es-ES', { month: 'long' });

function tituloDia(arg) {
  const f = aFecha(arg.date);
  const dia = capitalizar(f.toLocaleDateString('es-ES', { weekday: 'long' }));
  return `${dia} ${f.getDate()} ${nombreMes(f)} ${f.getFullYear()}`;
}

function tituloSemana(arg) {
  const ini = aFecha(arg.start);
  const fin = aFecha(arg.end || arg.start);   // en el título FullCalendar ya pasa el fin inclusivo
  if (ini.getFullYear() !== fin.getFullYear()) {
    return `${ini.getDate()} ${nombreMes(ini)} ${ini.getFullYear()} – ${fin.getDate()} ${nombreMes(fin)} ${fin.getFullYear()}`;
  }
  if (ini.getMonth() !== fin.getMonth()) {
    return `${ini.getDate()} ${nombreMes(ini)} – ${fin.getDate()} ${nombreMes(fin)} ${fin.getFullYear()}`;
  }
  return `${ini.getDate()} – ${fin.getDate()} ${nombreMes(ini)} ${fin.getFullYear()}`;
}

function tituloMes(arg) {
  const f = aFecha(arg.date);
  return `${capitalizar(nombreMes(f))} ${f.getFullYear()}`;
}
export default {
  name: 'PlanningFullcalendarGlobal',
  components: {
    FullCalendar, Dialog, Calendar, Textarea, Button,
    trabajosrealizadosoperarios, planningcomunicaciones, Presupuestos,
    MultiSelect, OverlayPanel,
    'servicio-datos-visitas-visita': serviciodatosvisitasvisita,
  },
  // Mismos props que el planning global antiguo (PlanningCalendario.vue)
  // + asegurado y especioperarioseleccionado (opcionales, para el flujo de nueva cita)
  props: [
    'id', 'servicio', 'operarios', 'operariosseleccionados',
    'especioperario', 'cambios', 'fechacal', 'guardia',
    'asegurado', 'especioperarioseleccionado'
  ],

  data() {
    return {
      noarrastrarcitas: false,
      confirmacionvisible: false,
      eventoamodificar: null,
      chatsPorVisita: {},
      tipoamodificar: '',
      idServicioIpas: 0,
      distanciaevento: '',
      colorkmevento: '',
      esVistaDiaria: true,
      envioX: 0,
      envioY: 0,
      envioAbierto: null,
      subTooltipVisible: false,
      subTooltipX: 0,
      subTooltipY: 0,
      subTooltipHtml: '',
      modoEspecialidadPrimero: false,
      franjaTooltip: null,
      detalleOculto: false,
      spinner: false,
      difuminado: '',
      esVistaMes: false,
      compacto: false,
      ocultar: false,
      overlayDiaVisible: false,
      overlayDiaX: 0, overlayDiaY: 0,
      citasDiaHover: [],
      tituloDiaHover: '',
      altura: '50vw',
      overlayVisible: false,
      overlayX: 0, overlayY: 0,
      overlayHideTimer: null,
      overlayBloqVisible: false,
      overlayBloqX: 0, overlayBloqY: 0,
      eventoHover: null,
      descripcionevento: '',
      nombreevento: '',
      descripcionbloq: '',
      cargandoOver: [],
      chatsvisita: '',
      fechacalddos: null,
      visible: false,
      nevisible: false,
      citaconfirmar: false,
      titulo: '',
      infoevento: '',
      eventoamostrar: '',
      editar: false,
      finalizar: false,
      trabajos: false,
      presupuestos: false,
      mostrarcomunicaciones: false,
      nomodificar: '0',
      prioritaria: '0',
      fechainicioeditar: new Date(),
      fechafineditar: new Date(),
      trabajosrealizadostexto: '',
      trabajospendientestexto: '',
      operariosingular: '',
      colorboton: 'normal', colorbotondos: 'normal',
      colorbotontres: 'normal', colorbotoncuatro: 'normal',
      totalrent: '', totalcliente: '', totaloperario: '',
      ocultarcliente: false, ocultaroperario: false,
      eventoacrear: new Date(),
      operarioseleccionado: '',
      especialidadseleccionada: this.especioperarioseleccionado || '',
      especialidades: [],
      especialidadesdos: [],
      fechainicio: '', fechafin: '',
      clientes: [], clienteseleccionado: '',
      clientedescripcion: [], clientesubir: [],
      descripcionvisitas: '', descripcionminima: 0,
      equipos: [], equiposseleccionado: [], equiposanyadir: [],
      pedidos: [], pedidosSeleccionados: [],
      confirmar_cita: '', medicion: '0',
      plantilladescripcionseleccionada: '',
      mostrarPlantillas: false,
      propiedadescalendario: '',
      propiedadescalendariooper: { plantillas_descripcion_visita: {} },
      id_reserva_visita: 0, id_visita: 0,
      direcciones: [],
      porconfimaractivado: false,
      trabajosservactivado: false, trabajosserv: [], trabajoservseleccionado: '',
      telefonosactivado: false, telefonoseleccionado: '',
      prestiacionesactivado: false, prestaciones: [], prestacionseleccionada: 0,
      equiposactivado: false, pedidosactivado: false,
      documentosactivado: false, documentos: [],
      gruposactivado: false, grupos: [],
      presupuestosactivado: false, presupuestoss: [],
      medicionactivada: false,
      ipas: false, razones: [], subrazones: [],
      razonipas: '', subrazonipas: '',
      valoresipas: [], motivo: '', cancelacion: '',
      datoscitaconfirmar: {},
      operariossplit: [],
      bloqueConfirmar: false,
      bloqueAEliminar: null,
      permiteEliminarFinalizada: false,
      listadofestivos: [],
      nombrefestividad: '',
      anyoactual: String(new Date().getFullYear()),
      mesactual: new Date().getMonth() + 1,
      diaactual: new Date().getDate(),
      color: ['blue','green','orange','red','purple','yellow','silver','aqua','maroon','lime','navy','fuchsia','olive'],
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin, resourceTimeGridPlugin, scrollGridPlugin],
        initialView: 'resourceTimeGridDay',
        schedulerLicenseKey: '0153147561-fcs-1782138727',
        locale: 'es',
        resources: [],
        views: {
  timeGridWeek: {
    slotEventOverlap: false,
    titleFormat: tituloSemana,
  },
  resourceTimeGridDay: {
    slotEventOverlap: false,
    titleFormat: tituloDia,
  },
  dayGridMonth: {
    titleFormat: tituloMes,
  },
},
        firstDay: 1,
        dayMinWidth: 150,
        slotDuration: '00:30:00',
        snapDuration: '00:15:00',
        allDaySlot: false,
        eventOverlap: true,
        height: 'auto',
        slotMinTime: '07:00:00',
        slotMaxTime: '22:00:00',
        nowIndicator: true,
        editable: true,
        eventStartEditable: true,
        eventDurationEditable: true,
        eventResourceEditable: true,
        resourceOrder: 'name',
        customButtons: {
          compacto: { text: 'Compacto', click: null },
        },
        headerToolbar: {
          left: '',
          center: 'prev title next today compacto',
          right: 'resourceTimeGridDay,timeGridWeek,dayGridMonth',
        },
        buttonText: { today: 'Hoy', day: 'Día', week: 'Semana', month: 'Mes' },
        selectable: false,
        unselectAuto: true,
        // todos los handlers se asignan en mounted()
        datesSet: null,
        eventDragStart: null,
        eventDrop: null,
        eventResize: null,
        eventClick: null,
        eventMouseEnter: null,
        eventMouseLeave: null,
        eventContent: null,
        resourceLabelContent: null,
        slotLabelContent: null,
        events: null,
      },
    };
  },

  methods: {
    // ── Utilidades ────────────────────────────────────────────────────────────
    decode_utf8(s) {
      try { return decodeURIComponent(escape(s)); } catch (e) { return s; }
    },
    formatFecha(date) {
      if (!date) return '';
      return new Date(date).toLocaleString('es-ES', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' });
    },
    formatHora(date) {
      if (!date) return '';
      return new Date(date).toLocaleTimeString('es-ES', { hour:'2-digit', minute:'2-digit' });
    },
    sumarDias(dia, mes, año, n) {
      const f = new Date(año, mes - 1, dia);
      f.setDate(f.getDate() + n);
      return `${String(f.getDate()).padStart(2,'0')}-${String(f.getMonth()+1).padStart(2,'0')}-${f.getFullYear()}`;
    },
  async comprobarParametroArrastrar() {
  const api = new PwgsApi();
  try {
    const aux = await api.get('parametros-pwgs/planning_no_arrastrar_citas');
    this.noarrastrarcitas = String(aux?.planning_no_arrastrar_citas) === '1';
  } catch (error) {
    console.error('Error al comprobar el parámetro de arrastrar citas:', error);
    this.noarrastrarcitas = false;
  }
  this.aplicarParametroArrastrar();
},
aplicarParametroArrastrar() {
  const puede = !this.noarrastrarcitas;
  this.calendarOptions.eventStartEditable    = puede;
  this.calendarOptions.eventResourceEditable = puede;
  // Aplicarlo también directamente en la instancia y repintar las citas ya cargadas
  const fc = this.$refs.fullCalendar?.getApi();
  if (fc) {
    fc.setOption('eventStartEditable', puede);
  fc.setOption('eventResourceEditable', puede);
  if (this.noarrastrarcitas) fc.refetchEvents();
  }
},
    onShowPanel() {},

    // ── CSS global inyectado en <head> una sola vez ───────────────────────────
    inyectarCSS() {
      if (document.getElementById('pwgs-fc-global-styles')) return;
      const s = document.createElement('style');
      s.id = 'pwgs-fc-global-styles';
      s.textContent = `
        .fc-timegrid-slot { height: 2.4em !important; }
        .fc-timegrid-slot-label-cushion { font-size:0.9em !important; font-weight:600; color:#333; padding:0 6px; white-space:nowrap; }
        .fc-timegrid-slot-minor .fc-timegrid-slot-label-cushion { font-weight:400; color:#999; }
        .fc-timegrid-axis, .fc-timegrid-slot-label { border-right: 2px solid #888 !important; }
        .fc-timegrid-slot-lane { border-top: none; }
        .fc-timegrid-slot-lane:not(.fc-timegrid-slot-minor) { background-color:#e8e8e8 !important; border-top: none !important; }
        /* Separadores de columna — se aplican sobre los divs de recurso (encima del fondo) */
        .fc-timegrid-col { border-right: 1px solid #999 !important; position: relative; z-index: 2; }
        /* El fondo gris/blanco va en z-index inferior para que el borde del col sea visible */
        .fc-timegrid-slots { z-index: 1 !important; position: relative; }
        .fc-timegrid-cols { z-index: 2 !important; position: relative; border-left: 1px solid #999 !important; }
        .fc-col-header-cell { border-right: 1px solid #999 !important; border-bottom: none !important; border-top: none !important; }
        .fc-scrollgrid-section-header td { border-bottom: none !important; border-top: none !important; }
        .fc-col-header { border-bottom: none !important; border-top: none !important; }
        .fc-scrollgrid-section-header .fc-scrollgrid-sync-inner { border-bottom: none !important; }
        th.fc-col-header-cell { border-bottom: none !important; }
        .fc-scrollgrid td, .fc-scrollgrid th { border-bottom: none !important; }
        .fc-scrollgrid-section-header > * { border-bottom: none !important; }
        /* Fondo de las celdas en el col (no en slots) para que respete el borde */
        .fc-timegrid-col:not(.fc-day-today) { background: transparent; }
        .fc-timegrid-col.fc-day-today { background: transparent !important; }
        /* Franjas alternas aplicadas al col directamente via nth */
        .fc-day-today { background: transparent !important; }
        .fc-col-header-cell-cushion { display:block; padding:4px; white-space:normal; }
        .fc-header-toolbar { margin-bottom:0 !important;padding-right: 0.5em; }
        .fc-toolbar-title { border-radius:4px; padding:2px 6px; transition:background 0.3s, filter 0.2s; cursor: pointer; }        .fc-event:hover { box-shadow:0 4px 12px rgba(0,0,0,0.2); z-index:999 !important; }
        .fc-event:hover .fc-event-btns { opacity:1 !important; }
        .fc-event.GUARDIA    { background:rgba(255,87,87,1) !important; color:white !important; border:none !important; }
        .fc-event.OCUPADO    { background:rgba(0,47, 255,1) !important; color:white !important; border:none !important; }
        .fc-event.BLOQUEADO  { background:rgba(71,98,104,1) !important; color:white !important; border:none !important; }
        .fc-event.VACACIONES { background:rgba(0,204,0,1) !important; color:white !important; border:none !important; }
        .pwgs-watermark { position:absolute; right:4px; font-size:0.65em; color:rgba(0,0,0,0.13); pointer-events:none; user-select:none; z-index:1; line-height:1; }
        .pwgs-watermark.hora-entera { color:rgba(0,0,0,0.20); font-weight:600; }
        .fc-view-harness { margin-top: 0 !important; }
        .fc-scrollgrid-section-header td { padding: 0 !important; }
        .fc-col-header { margin: 0 !important; }
        .fc-daygrid-body, .fc-timegrid-body { margin-top: 0 !important; }
        .fc .fc-toolbar { margin-bottom: 4px !important; }
        .fc-scrollgrid { border-top: none !important; }
        /* Sticky header operarios/días — por debajo del menú superior del programa */
        .fc .fc-col-header {
          position: sticky !important;
          top: 72px !important;
          z-index: 50 !important;
          background: white !important;
        }
        .fc-scrollgrid-section-header {
          position: sticky !important;
          top: 72px !important;
          z-index: 50 !important;
        }
        .fc-scrollgrid-section-header td {
          position: sticky !important;
          top: 72px !important;
          z-index: 50 !important;
          background: white !important;
        }
        .fc-toolbar.fc-header-toolbar {
          flex-wrap: nowrap !important;
        }
        .fc-toolbar-chunk {
          display: flex !important;
          align-items: center !important;
          white-space: nowrap !important;
        }
        .fc-toolbar-title {
          white-space: nowrap !important;
          font-size: 2.1em !important;
        }
        .p-overlaypanel { z-index: 100000 !important; }
        .p-dialog-mask { z-index: 100000 !important; }
        .p-dialog { z-index: 100001 !important; }
        .p-datepicker { z-index: 100002 !important; }
        .fc-timegrid-event { overflow: visible !important; }
    /* Al no solaparse ya no hace falta la sombra de "inset" de FullCalendar */
      .fc-resourceTimeGridDay-view .fc-timegrid-event-harness-inset .fc-timegrid-event {
        box-shadow: none !important;
      }
      /* ── Vista diaria: el hover solo se activa dentro del área real de la cita ──
         Los botones ocultos (opacity:0) desbordan por debajo y capturaban el ratón,
         expandiendo la cita al pasar por la franja inferior. Recortándolos mientras
         no hay hover dejan de ser objetivo del puntero. */
      .fc-resourceTimeGridDay-view .fc-timegrid-event-harness > .fc-timegrid-event {
        overflow: hidden !important;
      }
      .fc-resourceTimeGridDay-view .fc-timegrid-event-harness:hover > .fc-timegrid-event {
        overflow: visible !important;
      }


        .fc-timegrid-event .fc-event-main { overflow: visible !important; padding: 0 !important; }
        .fc-event:hover { z-index: 999 !important; }
        .fc-timegrid-event-harness:hover { z-index: 999 !important; }
        .fc-timegrid-event-harness:hover .fc-timegrid-event {
          min-height: 60px !important;
          box-shadow: 0 4px 12px rgba(0,0,0,0.25);
          transition: min-height 0.12s ease, box-shadow 0.12s ease;
        }
        .p-multiselect-panel { z-index: 100002 !important; }
        .fc-daygrid-event.CONTADOR,
        .fc-daygrid-event.FESTIVO_MES,
        .fc-event.CONTADOR,
        .fc-event.FESTIVO_MES {
          background: transparent !important;
          border: none !important;
          box-shadow: none !important;
          margin: 0 !important;
        }
        /* Centrar el contenido dentro de la celda del día */
        .fc-daygrid-day-events:has(.CONTADOR),
        .fc-daygrid-day-events:has(.FESTIVO_MES) {
          display: flex;
          justify-content: center;
        }
      .fc-daygrid-event.CONTADOR .fc-event-main,
      .fc-daygrid-event.FESTIVO_MES .fc-event-main {
        display: flex;
        justify-content: center;
      }
      .fc-daygrid-day-events { display: flex; justify-content: center; }
      /* En la vista mensual, ocultar cualquier evento que no sea contador/festivo
      (evita el parpadeo de las citas cacheadas antes de cargar el contador) */
      .fc-dayGridMonth-view .fc-daygrid-event:not(.CONTADOR):not(.FESTIVO_MES) {
        display: none !important;
      }
      /* ── Modo compacto: sin eje de horas, todo visible en pantalla ── */
      .pwgs-compacto .fc-timegrid-axis,
      .pwgs-compacto td.fc-timegrid-slot-label {
        display: none !important;
      }
      .pwgs-compacto td.fc-timegrid-slot,
      .pwgs-compacto td.fc-timegrid-slot-lane {
        height: 14px !important;
        line-height: 14px !important;
        padding: 0 !important;
      }
      /* Las horas enteras dentro de las columnas hacen de eje: más visibles */
      .pwgs-compacto .pwgs-watermark { font-size: 0.6em; }
      .pwgs-compacto .pwgs-watermark:not(.hora-entera) { display: none !important; }
      .pwgs-compacto .pwgs-watermark.hora-entera { color: rgba(0,0,0,0.45) !important; font-weight: 700; }
      .pwgs-compacto .fc-timegrid-event .fc-event-main { font-size: 0.85em; }
      .pwgs-compacto .fc-col-header-cell-cushion { padding: 1px; font-size: 0.85em; }
      /* Día festivo en vista mensual: número en verde con texto blanco */
      .fc-dayGridMonth-view .pwgs-dia-festivo .fc-daygrid-day-number {
        background: #28a745 !important;
        color: #fff !important;
        border-radius: 4px;
        padding: 1px 7px;
        font-weight: 600;
      }
      /* Día festivo en cabecera de vista semanal: verde con texto blanco */
      .fc-timeGridWeek-view .pwgs-dia-festivo .fc-col-header-cell-cushion,
      th.pwgs-dia-festivo .fc-col-header-cell-cushion {
        background: #28a745 !important;
        color: #fff !important;
        border-radius: 4px;
        padding: 1px 7px;
        font-weight: 600;
      }
      .fc-event.RESUMEN { border: 1px solid rgba(0,0,0,0.15) !important; opacity: 0.85; cursor: default; }
      .fc-event.RESUMEN:hover { box-shadow: 0 2px 8px rgba(0,0,0,0.2); }
      .fc-timeGridWeek-view .fc-col-header-cell-cushion { cursor: pointer; }
      .fc-timeGridWeek-view .fc-col-header-cell-cushion:hover { text-decoration: underline; }
      /* En la vista semanal, ocultar cualquier evento que no sea el resumen
      (evita el parpadeo de las citas cacheadas de la vista diaria) */
      .fc-timeGridWeek-view .fc-timegrid-event:not(.RESUMEN),
      .fc-timeGridWeek-view .fc-daygrid-event:not(.RESUMEN) {
        display: none !important;
      }
      .fc-bg-event .fc-event-main, .fc-bg-event { height: 100%; }
      /* Sombreado completo para bloqueos y ocupados (como Vacaciones) */
      .fc-bg-event.BLOQUEADO,
      .fc-bg-event.OCUPADO,
      .fc-bg-event.VACACIONES {
        opacity: 1 !important;
      }
      /* Guardia se queda con la opacidad por defecto de FullCalendar (difuminado) */
      /* En la vista semanal, ocultar cualquier evento que no sea el resumen
      (evita el parpadeo de las citas y fondos cacheados de la vista diaria) */
      .fc-timeGridWeek-view .fc-timegrid-event:not(.RESUMEN),
      .fc-timeGridWeek-view .fc-daygrid-event:not(.RESUMEN),
      .fc-timeGridWeek-view .fc-bg-event {
        display: none !important;}
      .fc-timeGridWeek-view .fc-timegrid-event:hover,
      .fc-timeGridWeek-view .fc-timegrid-event.RESUMEN:hover {
        transform: none !important;
        min-height: 0 !important;
        height: 100% !important;
        max-height: 100% !important;
        box-shadow: none !important;
        z-index: 1 !important;
      }
      /* Bloques RESUMEN siempre a ancho completo en semanal */
      .fc-timeGridWeek-view .fc-timegrid-event-harness {
        left: 0 !important;
        right: 0 !important;
      }
      /* Sin margen lateral en los bloques de la vista semanal (ocupan toda la celda) */
      .fc-timeGridWeek-view .fc-timegrid-col-events {
        margin: 0 !important;
      }
      /* Cabecera de operario preferente */
      .fc .fc-col-header-cell.col-preferente {
        background: #f9cc98 !important;
      }
      /* ── Vista diaria: la cita ocupa casi todo el ancho de su hueco ────────── */
      /* FullCalendar reserva por defecto un 2.5% a cada lado de la columna */
      .fc-resourceTimeGridDay-view .fc-timegrid-col-events {
        margin: 0 1px !important;
      }
      /* El evento rellena por completo su harness (sin escalonado por solape) */
      .fc-resourceTimeGridDay-view .fc-timegrid-event-harness > .fc-timegrid-event {
        inset-inline-start: 0 !important;
        inset-inline-end: 0 !important;
        left: 0 !important;
        right: 0 !important;
      }
      /* Mínima separación entre dos citas que compartan franja */
      .fc-resourceTimeGridDay-view .fc-timegrid-event {
        margin-right: 1px !important;
      }
      /* Al no solaparse ya no hace falta la sombra de "inset" de FullCalendar */
      .fc-resourceTimeGridDay-view .fc-timegrid-event-harness-inset .fc-timegrid-event {
        box-shadow: none !important;
      }
      `;
      document.head.appendChild(s);
    },

    ponerMarcasDeAgua() {
      if (this._marcasInterval) { clearInterval(this._marcasInterval); }
      setTimeout(() => {
        // Limpiar marcas anteriores para no duplicar al recargar
        document.querySelectorAll('.pwgs-watermark').forEach(el => el.remove());
        const lanes = document.querySelectorAll('td.fc-timegrid-slot-lane[data-time]');

        // Una columna por operario (excluimos el eje de horas)
        const frames = document.querySelectorAll('.fc-timegrid-col:not(.fc-timegrid-axis) .fc-timegrid-col-frame');
        if (!lanes.length || !frames.length) return;
        lanes.forEach(td => {
          const timeStr = td.getAttribute('data-time') || '';
          const hh = timeStr.substring(0, 2);
          const mm = timeStr.substring(3, 5);
          if (!hh || !mm) return;
          const isHour = mm === '00';
          const top = td.offsetTop; // misma altura que la franja de fondo
          frames.forEach(frame => {
            const span = document.createElement('span');
            span.className = 'pwgs-watermark' + (isHour ? ' hora-entera' : '');
            span.textContent = hh + ':' + mm;
            span.style.top = (top + 2) + 'px';
            frame.appendChild(span);
          });
        });
      }, 300);
    },


    // ── Recursos (operarios como columnas) ───────────────────────────────────
    cargarRecursos() {
      if (!this.operarios) return;
      const recursos = [];
      const seleccionados = this.operariosseleccionados || [];
      // Ordenar alfabéticamente igual que en el padre
      const operariosOrdenados = [...Object.values(this.operarios)].sort((a, b) =>
        (a.nombre || '').localeCompare(b.nombre || '', 'es')
      );
      for (const op of operariosOrdenados) {
        if (!op.nombre) { continue; }
        if (seleccionados.length > 0 && !seleccionados.includes(op.idoperario)) { continue; }
        recursos.push({
          id: String(op.idoperario),
          title: op.nombre,
          name: op.nombre,
          extendedProps: {
            carga: op.carga_operario,
            guardia: op.guardia,
            interpwgs: op.interpwgs,
            preferente: op.preferente_operario,
            autovisita: op.autovisita,
            observaciones: op.observaciones_operario,
            telefono1: op.telefono1,
          },
        });
      }
      this.operariossplit = recursos.map(r => ({ id: r.id, label: r.title }));
      this.calendarOptions.resources = recursos;
      this.ocultar = recursos.length === 0;
    },
    toggleCompacto() {
      this.compacto = !this.compacto;
      // Actualizar el texto del botón vía opciones (evita duplicados al re-renderizar la toolbar)
      this.calendarOptions.customButtons = {
        compacto: {
          text: this.compacto ? 'Normal' : 'Compacto',
          click: this.toggleCompacto,
        },
      };
      this.$nextTick(() => {
        const api = this.$refs.fullCalendar?.getApi();
        setTimeout(() => { api?.updateSize(); }, 50);
        setTimeout(() => { api?.updateSize(); this.ponerMarcasDeAgua(); }, 350);
      });
    },
    _bloquearScroll() {
      this._scrollLocks = (this._scrollLocks || 0) + 1;
      if (this._scrollLockHandler) return;
      this._scrollLockY = (this._scrollY !== undefined && this._scrollY !== null) ? this._scrollY : window.scrollY;

      // Detectar interacción real del usuario (rueda, táctil, teclado)
      this._marcaUsuario = 0;
      this._userInputHandler = () => { this._marcaUsuario = Date.now(); };
      window.addEventListener('wheel', this._userInputHandler, { passive: true });
      window.addEventListener('touchmove', this._userInputHandler, { passive: true });
      window.addEventListener('keydown', this._userInputHandler);

      this._scrollLockHandler = () => {
        if (Date.now() - this._marcaUsuario < 150) {
          // Scroll iniciado por el usuario → seguirle, no corregir
          this._scrollLockY = window.scrollY;
        } else if (window.scrollY !== this._scrollLockY) {
          // Scroll programático (focus-restore, reflow) → revertir
          window.scrollTo(0, this._scrollLockY);
        }
      };
      window.addEventListener('scroll', this._scrollLockHandler);
    },

    _desbloquearScroll() {
      this._scrollLocks = Math.max((this._scrollLocks || 1) - 1, 0);
      if (this._scrollLocks > 0) return;
      if (this._scrollLockHandler) {
        window.removeEventListener('scroll', this._scrollLockHandler);
        this._scrollLockHandler = null;
      }
      if (this._userInputHandler) {
        window.removeEventListener('wheel', this._userInputHandler);
        window.removeEventListener('touchmove', this._userInputHandler);
        window.removeEventListener('keydown', this._userInputHandler);
        this._userInputHandler = null;
      }
    },
    // ── Cabecera columna operario ─────────────────────────────────────────────
    buildResourceLabelContent(arg) {
      const ep = arg.resource.extendedProps || {};
      const tel = ep.telefono1 || '';
      const clicktocall = `window.open('sip:${tel}','_self'); return false;`;
      let html = ``;
      if (ep.autovisita == 1) html += `<i title="Operario configurado para Autovisita" class="fas fa-lightbulb" style="color:rgb(225,225,1)"></i>&nbsp;`;
      const nombreCompleto = arg.resource.title;
      const nombreCorto = nombreCompleto.length > 27 ? nombreCompleto.substring(0, 24) + '…' : nombreCompleto;

      html += `<strong title="${nombreCompleto}">${nombreCorto}</strong><br>`;
      if (ep.interpwgs == 1) html += `<strong>[INTERPWGS]</strong>`;
      if (ep.preferente == 1) html += `<strong>[Preferente]</strong>`;
      if (ep.guardia == 1) html += `<strong>[Guardia]</strong>`;
      html += `</td></tr><tr><td style="text-align:center">`;
      if (ep.observaciones) html += `<i title="Observaciones\n${ep.observaciones}" class="pi pi-exclamation-triangle" style="color:#f00"></i>`;
      html += `<strong>[${ep.carga || 0}%]</strong> <a href="#" onclick="${clicktocall}"><i class="pi pi-phone"></i></a>`;
      return { html };
    },

    // ── Contenido visual evento (SOLO LECTURA: sin botones de edición) ────────
    buildEventContent(arg) {
      const ep = arg.event.extendedProps;
      const tipo = ep.tipo || arg.event.title;
       // ── Bloque resumen en vista semanal ──
      if (tipo === 'RESUMEN') {
        const d = new Date(ep.franjaIni);
        const hora = `${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
        let izq = '';
        const sel = Array.isArray(this.operariosseleccionados) ? this.operariosseleccionados : [];
        if (sel.length === 1 && (ep.poblacion || ep.cp)) {
          const colorKmR = ep.color_km || '';
          izq = `${ep.poblacion || ''}`;
          if (ep.cp) {
            izq += `&nbsp;<span style="background-color:${colorKmR}">(${ep.cp})</span>`;
          }
        }
        return { html: `<div style="height:100%;display:flex;justify-content:space-between;gap:4px;font-size:0.7em;color:#555;padding:1px 3px;overflow:hidden">
          <span style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis">${izq}</span>
          <span style="flex:0 0 auto">${hora}</span>
        </div>` };
      }
       if (tipo === 'CONTADOR') {
        let h = `<div style="display:flex;gap:3px;flex-wrap:wrap;padding:1px;justify-content:center">`;
        if (ep.activas > 0)
          h += `<span title="Activas" style="background:#ffe88c;color:#000;border-radius:3px;padding:0 5px;font-weight:bold;font-size:0.85em">${ep.activas}</span>`;
        if (ep.confirmar > 0)
          h += `<span title="Por confirmar" style="background:#f89393;color:#000;border-radius:3px;padding:0 5px;font-weight:bold;font-size:0.85em">${ep.confirmar}</span>`;
        if (ep.finalizadas > 0)
          h += `<span title="Finalizadas" style="background:#e8eff4;color:#000;border-radius:3px;padding:0 5px;font-weight:bold;font-size:0.85em">${ep.finalizadas}</span>`;
          h += `</div>`;
        return { html: h };
        }
      if (tipo === 'FESTIVO_MES') {
        return { html: `<span title="Festivo: ${ep.festivostitle}" style="background:#126e12;color:#fff;border-radius:3px;padding:0 6px;font-weight:bold;font-size:0.85em">F</span>` };
      }
      const especiales = ['GUARDIA','OCUPADO','BLOQUEADO','VACACIONES','RESERVA'];
      if (especiales.includes(tipo)) {
        const alineacion = {
          GUARDIA:    'flex-start',
          OCUPADO:    'flex-end',
          BLOQUEADO:  'center',
          VACACIONES: 'flex-start',
          RESERVA:    'center',
        };
        let botonEliminar = '';
        if (tipo === 'VACACIONES' || tipo === 'BLOQUEADO') {
          botonEliminar = `<div class="fc-event-btns" style="display:flex;justify-content:center;margin-top:2px;opacity:0;transition:opacity 0.15s;pointer-events:auto">
            <button title="Eliminar ${tipo === 'VACACIONES' ? 'vacaciones' : 'bloqueo'}"
              style="background:#fffa;border:1px solid #0002;border-radius:3px;padding:1px 4px;font-size:0.7em;cursor:pointer;color:#c00;line-height:1.2"
              onmousedown="event.stopPropagation();event.preventDefault();"
              ontouchstart="event.stopPropagation();"
              onclick="event.stopPropagation();window.__fcGlobalEliminarBloque('${ep.id_visita || ''}','${ep.idservicio || ''}','${tipo}','${ep.id_bloqueo || ''}','${ep.id_operario || ''}')">
              <i class="fas fa-times"></i>
            </button>
          </div>`;
        }
        return { html: `<div style="height:100%;display:flex;flex-direction:column;justify-content:${alineacion[tipo] || 'center'};text-align:center;font-weight:bold;padding:2px;box-sizing:border-box">${tipo}${botonEliminar}</div>` };
      }
      const color = ep.color || '#ffe88c';
      const porConfirmar = color.toLowerCase() === '#ff4646';
      const coloresTextoNegro = ['#ffe88c', '#e8eff4', '#f5c505'];
      const textColor = coloresTextoNegro.includes(color.toLowerCase()) ? 'black' : 'white';      const pob = ep.poblacion ? this.decode_utf8(ep.poblacion) : '';
      const cp = ep.cp || '';
      const colorKm = ep.color_km || '';
      const idVisita = ep.id_visita || '';
      const idServicio = ep.idservicio || '';
      const tieneFirma = ep.tiene_firma || '0';
      const finalizada = ep.finalizada || '0';
      

      const btn = (onclick, title, icon, extraStyle) =>
        `<button title="${title}"
          style="background:#fffa;border:1px solid #0002;border-radius:3px;padding:1px 4px;font-size:0.7em;cursor:pointer;color:#333;line-height:1.2;${extraStyle||''}"
          onclick="event.stopPropagation();${onclick}">
          <i class="${icon}"></i>
        </button>`;

      let html = `<div style="background-color:${color};border:1px solid #000;color:${textColor};display:flex;flex-direction:column;justify-content:flex-start;padding:2px;height:100%;overflow:visible;box-sizing:border-box;position:relative;">`;

      // Título — siempre visible, no se recorta aunque la cita sea muy corta
      html += `<div style="font-size:0.8em;font-weight:bold;line-height:1.1;flex:0 0 auto;white-space:normal;word-break:break-word">${pob}`;
      if (cp) html += `&nbsp;<span style="background-color:${colorKm}">(${cp})</span>`;
      html += `</div>`;

      // Botones — mismos que visita_datos.vue, visibles al hover
      html += `<div class="fc-event-btns" style="display:flex;gap:2px;flex-wrap:wrap;margin-top:2px;opacity:0;transition:opacity 0.15s">`;
      // Ir al servicio
      html += btn(`window.__fcGlobalBtnClick('irservicio','${idVisita}','${idServicio}')`, 'Ir al servicio', 'fas fa-paste');
      // Eliminar — oculto en finalizadas si el parámetro no lo permite
      if (this.puedeEliminarCita(finalizada, color)) {
        html += btn(`window.__fcGlobalBtnClick('eliminar','${idVisita}','${idServicio}')`, 'Eliminar visita', 'fas fa-times', 'color:#c00;');
      }
      // Confirmar — solo si la cita está pendiente de confirmar
      if (porConfirmar) {
        html += btn(`window.__fcGlobalBtnClick('confirmar','${idVisita}','${idServicio}')`, 'Confirmar visita', 'fas fa-align-justify');
      }
      // Trabajos
      html += btn(`window.__fcGlobalBtnClick('trabajos','${idVisita}','${idServicio}')`, 'Mostrar Trabajos', 'far fa-plus-square');
      // Presupuesto
      html += btn(`window.__fcGlobalBtnClick('presupuesto','${idVisita}','${idServicio}')`, 'Presupuesto', 'far fa-folder-open');
      // Modificar
      html += btn(`window.__fcGlobalBtnClick('editar','${idVisita}','${idServicio}')`, 'Modificar visita', 'far fa-edit');
      // Chat (con contador de mensajes)
const nChats = Number(this.chatsPorVisita[idVisita] || 0);
html += `<span style="position:relative;display:inline-block">
${btn(`window.__fcGlobalBtnClick('chat','${idVisita}','${idServicio}')`, 'Chat', 'far fa-comment-dots')}
  <span data-chat-badge="${idVisita}"
    style="position:absolute;top:-6px;right:-6px;min-width:14px;height:14px;padding:0 3px;border-radius:7px;background:#dc3545;color:#fff;font-size:0.6em;line-height:14px;text-align:center;font-weight:bold;pointer-events:none;display:${nChats > 0 ? 'inline-block' : 'none'}">${nChats}</span>
</span>`;
    // Finalizar
      html += btn(`window.__fcGlobalBtnClick('finalizar','${idVisita}','${idServicio}')`, 'Finalizar visita', 'fas fa-check');

      // Envíos (share)
      html += `<div style="position:relative;display:inline-block">
        <button title="Envíos"
          style="background:#fffa;border:1px solid #0002;border-radius:3px;padding:1px 4px;font-size:0.7em;cursor:pointer;color:#333;line-height:1.2"
          onclick="event.stopPropagation();window.__fcGlobalToggleDropdown('ddg_${idVisita}')">
          <i class="fas fa-share-square"></i>
        </button>
        <ul id="ddg_${idVisita}" style="display:none;position:absolute;bottom:100%;left:0;background:#fff;border:1px solid #ccc;border-radius:4px;list-style:none;padding:4px 0;margin:0;z-index:9999;min-width:160px;box-shadow:0 2px 8px rgba(0,0,0,0.2);font-size:0.8em">
          <li style="padding:4px 10px;cursor:pointer" onclick="event.stopPropagation();window.__fcGlobalBtnClick('fichaemail','${idVisita}','${idServicio}')">Enviar ficha email</li>
          <li style="padding:4px 10px;cursor:pointer;border-top:1px solid #eee" onclick="event.stopPropagation();window.__fcGlobalBtnClick('smsoperario','${idVisita}','${idServicio}')">SMS al operario</li>
          <li style="padding:4px 10px;cursor:pointer" onclick="event.stopPropagation();window.__fcGlobalBtnClick('smsasegurado','${idVisita}','${idServicio}')">SMS al asegurado</li>
          <li style="padding:4px 10px;cursor:pointer" onclick="event.stopPropagation();window.__fcGlobalBtnClick('ste','${idVisita}','${idServicio}')">Firma STE email</li>
        </ul>
      </div>`;

      // Parte genérico
      html += btn(`window.__fcGlobalBtnClick('parte','${idVisita}','${idServicio}')`, 'Parte genérico', tieneFirma === '1' ? 'fas fa-file-signature' : 'far fa-file');
      html += `</div></div>`;
      return { html };
    },

    // ── Etiqueta lateral HH:MM ────────────────────────────────────────────────
    buildSlotLabelContent(arg) {
      const hh = String(arg.date.getHours()).padStart(2, '0');
      const mm = String(arg.date.getMinutes()).padStart(2, '0');
      return { html: `<span>${hh}:${mm}</span>` };
    },
    buscarFestivo(dateStr) {
      const f = (this.listadofestivos || []).find(x => (x.fecha || '').substring(0, 10) === dateStr);
      return f ? (f.nombre || 'Festivo') : '';
    },
    // ── Fetch de eventos (función para FullCalendar, sin bucle) ──────────────
     async fetchEvents(fetchInfo, successCallback, failureCallback) {
      try {
        const api = new PwgsApi();
        const pad = (n) => String(n).padStart(2, '0');
        const fmt = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

        const start = fmt(fetchInfo.start);
        const end   = fmt(new Date(fetchInfo.end.getTime() - 1)); // end es exclusivo

        // Detección robusta por rango: el mes abarca >14 días
        const diasRango = Math.round((fetchInfo.end.getTime() - fetchInfo.start.getTime()) / 86400000);
        const esMes = diasRango > 14;

      if (esMes) {
        const mid = new Date((fetchInfo.start.getTime() + fetchInfo.end.getTime()) / 2);
        this.anyoactual = String(mid.getFullYear());
        this.mesactual  = mid.getMonth() + 1;
        this.diaactual  = 1;
      }
      else {
        this.anyoactual = String(fetchInfo.start.getFullYear());
        this.mesactual  = fetchInfo.start.getMonth() + 1;
        this.diaactual  = fetchInfo.start.getDate();
      }
      this.comprobarfestivos();
      if (esMes) {
        this._enMes = true;
        const eventosMes = await this.cargarContadorMes(this.anyoactual, this.mesactual);
        successCallback(eventosMes);
        return;
      }
      this._enMes = false;
      // ── PLANNING GLOBAL: siempre sin id de servicio ──
      const cuerpo = {
        start: `${start}T00:00:00`,
        end:   `${end}T23:59:00`,
        id_servicio: 0,
      };
      // Si el filtro de operarios indica guardia (Sí o No), la consulta de citas también lo lleva
      if (this.guardia === true || this.guardia === false) {
        cuerpo.guardia = this.guardia;
      }
      const miseventos = await api.post('planning-pwgs', cuerpo);
      const especiales = ['GUARDIA','OCUPADO','BLOQUEADO','VACACIONES','RESERVA'];

      // Filtro de operarios (si no hay selección → todos)
      const sel = Array.isArray(this.operariosseleccionados) ? this.operariosseleccionados : [];
      const filtrar = sel.length > 0;
      const selStr = sel.map(x => String(x));

      // ¿Vista semanal? (rango de 7 días)
      const esSemana = diasRango === 7;
      const eventos = [];
      const resumenSemana = {}; // { 'YYYY-MM-DD': { start, end, count } }

      // El índice para el tooltip se construye SIEMPRE en semanal
      if (esSemana) {
        this.construirIndiceSemana(miseventos);
      }
      for (const ev of (miseventos || [])) {
        const esEspecial = especiales.includes(ev.title);

      // ── VISTA SEMANAL: agrupar por franjas de 30 min ──
        if (esSemana) {
          if (filtrar && !selStr.includes(String(ev.id_operario))) continue;
          if (esEspecial) continue;
          const s = new Date(ev.start);
          const e = new Date(ev.end);
          if (isNaN(s)) continue;
          const porConfirmar = (ev.color || '').toLowerCase() === '#ff4646';
          const distintoDia = s.toDateString() !== e.toDateString();
          if (porConfirmar && distintoDia) continue;

          // ¿La cita está finalizada? (color de finalizadas)
          const finalizada = (ev.color || '').toLowerCase() === '#e8eff4';

          // Marcar todas las franjas de 30 min que solapa la cita
          const slotMs = 30 * 60000;
          let t = Math.floor(s.getTime() / slotMs) * slotMs;
          for (; t < e.getTime(); t += slotMs) {
            const dFr = new Date(t);
            const diaFr = `${dFr.getFullYear()}-${String(dFr.getMonth()+1).padStart(2,'0')}-${String(dFr.getDate()).padStart(2,'0')}`;
            if (!resumenSemana[diaFr]) resumenSemana[diaFr] = new Map();
            const prev = resumenSemana[diaFr].get(t);
            const esMasTemprana = !prev || s.getTime() < prev.primeraTs;
            // La franja es "toda finalizada" solo si TODAS las citas que la tocan lo están
            resumenSemana[diaFr].set(t, {
              todasFinalizadas: (prev ? prev.todasFinalizadas : true) && finalizada,
              count: (prev ? prev.count : 0) + 1,
              primeraTs: esMasTemprana ? s.getTime() : prev.primeraTs,
              poblacion: esMasTemprana ? this.decode_utf8(ev.poblacion || '') : prev.poblacion,
              cp: esMasTemprana ? (ev.cp || '') : prev.cp,
              color_km: esMasTemprana ? (ev.color_km || '') : prev.color_km,
              distancia: esMasTemprana ? (ev.distancia || '') : prev.distancia,
            });
          }
          continue;
        }

        // ── VISTA DIARIA──
        let startEvt, endEvt;
        if ((ev.title === 'GUARDIA' || (ev.title === 'OCUPADO' && ev.dow)) && ev.dow) {
          const horaIni = (ev.start || '').padStart(5, '0');
          const horaFin = (ev.end   || '').padStart(5, '0');
          for (const day of ev.dow) {
            const offset = Number(day) - 1;
            const [d, m, a] = this.sumarDias(this.diaactual, this.mesactual, this.anyoactual, offset).split('-');
            startEvt = new Date(`${a}-${m}-${d}T${horaIni}`);
            endEvt   = new Date(`${a}-${m}-${d}T${horaFin}`);
            eventos.push(this._buildFCEvent(ev, startEvt, endEvt, esEspecial));
          }
          continue;
        }
        if (ev.title === 'GUARDIA' || (ev.title === 'OCUPADO' && ev.dow)) {
          const horaIni = (ev.start || '').padStart(5, '0');
          const horaFin = (ev.end   || '').padStart(5, '0');
          startEvt = new Date(`${start}T${horaIni}`);
          endEvt   = new Date(`${start}T${horaFin}`);
        }
        else {
          // ── Cita normal ──────────────────────────────────────────────
          startEvt = new Date(ev.start);
          endEvt   = new Date(ev.end);

          // ¿Es una cita "por confirmar"? (color #ff4646)
          const porConfirmar = ev.color === '#ff4646' || ev.color === '#FF4646';

          // ¿Abarca más de un día? (inicio y fin en días distintos)
          const distintoDia =
            startEvt.getFullYear() !== endEvt.getFullYear() ||
            startEvt.getMonth()    !== endEvt.getMonth()    ||
            startEvt.getDate()     !== endEvt.getDate();

          if (porConfirmar && distintoDia) {
            // Vista DIARIA: el fin toma el DÍA del inicio y la HORA del fin
            endEvt = new Date(
              startEvt.getFullYear(),
              startEvt.getMonth(),
              startEvt.getDate(),
              endEvt.getHours(),
              endEvt.getMinutes(),
              endEvt.getSeconds()
            );

            // Salvaguarda: si el fin queda antes o igual que el inicio, 1h por defecto
            if (endEvt <= startEvt) {
              endEvt = new Date(startEvt.getTime() + 3600000);
            }
          }
        }
        eventos.push(this._buildFCEvent(ev, startEvt, endEvt, esEspecial));
      }

      // ── VISTA SEMANAL: un bloque por cada franja de 30 min con citas ──
      if (esSemana) {
        const slotMs = 30 * 60000;
        for (const [dia, franjas] of Object.entries(resumenSemana)) {
          for (const [ini, infoF] of franjas) {
            eventos.push({
              id: `resumen_${dia}_${ini}`,
              title: '',
              start: new Date(ini),
              end: new Date(ini + slotMs),
              display: 'block',
              editable: false,
              durationEditable: false,
              color: infoF.todasFinalizadas ? '#e8eff4' : '#ffe88c',   // gris si todo finalizado
              classNames: ['RESUMEN'],
              extendedProps: {
                tipo: 'RESUMEN', dia, franjaIni: ini, franjaFin: ini + slotMs,
                count: infoF.count,
                poblacion: infoF.poblacion,
                cp: infoF.cp,
                color_km: infoF.color_km,
                distancia: infoF.distancia,
              },
            });
          }
        }
      }
      successCallback(eventos);
      this.$nextTick(() => setTimeout(() => this.ponerMarcasDeAgua(), 200));
      }
      catch (err) {
        console.error('Error fetchEvents:', err);
        failureCallback(err);
      }
      finally {
        this.spinner = false;
        if (this._elCongelado) {
          const el = this._elCongelado;
          this._elCongelado = null;
          setTimeout(() => {
            el.style.minHeight = '';
            this._desbloquearScroll();
          }, 150);
        }
        else {
          this._desbloquearScroll();
        }
      }
    },

    _buildFCEvent(ev, startEvt, endEvt, esEspecial) {
        const puedeArrastrar = !esEspecial && !this.noarrastrarcitas;
      return {
        id: String(ev.id) + '_' + Math.random(),
        resourceId: String(ev.id_operario),
        title: ev.title,
        start: startEvt,
        end: endEvt,
        color: esEspecial ? 'transparent' : (ev.color || '#ffe88c'),
        display: ev.rendering === 'background' ? 'background' : 'block',
        classNames: esEspecial ? [ev.title] : [],
         // Solo las citas normales se pueden arrastrar/redimensionar
        //editable: !esEspecial,
        durationEditable: !esEspecial,
         // Arrastrar (mover en el tiempo / cambiar de operario) según el parámetro
        startEditable: puedeArrastrar,
        resourceEditable: puedeArrastrar,
        extendedProps: {
          tipo: ev.title,
          color: ev.color,
          color_km: ev.color_km,
          poblacion: ev.poblacion,
          cp: ev.cp,
          content: ev.description,
          idservicio: ev.id_servicio,
          id_visita: ev.id,
          id_bloqueo: ev.id_bloqueo,
          id_operario: ev.id_operario,
          distancia: ev.distancia,
          fecha_original: ev.fecha_original,
          fecha_fin_original: ev.fecha_fin_original,
          // Flags para botones condicionales (igual que visita_datos.vue)
          accesible: ev.accesible || '0',
          modificable: ev.modificable || '0',
          finalizada: ev.finalizada || '0',
          confirmar: ev.confirmar || '0',
          tiene_firma: ev.tiene_firma || '0',
          url_parte: ev.url_parte || '',
        },
      };
    },

    recargar() {
      const el = this.$refs.fullCalendar?.$el;
      if (el) {
        el.style.minHeight = el.offsetHeight + 'px';
        this._elCongelado = el;
      }
      this._bloquearScroll();
      this.$refs.fullCalendar?.getApi()?.refetchEvents();
    },
    async comprobareliminarfinalizada() {
      const api = new PwgsApi();
      const finalizada = await api.get('parametros-pwgs/permite_eliminar_cita_info');
      return finalizada.permite_eliminar_cita_info == 1;
    },
     onEventDragStart() {
      this.cerrarop();
      this.overlayDiaVisible = false;
      if (this.overlayHideTimer) { clearTimeout(this.overlayHideTimer); this.overlayHideTimer = null; }
    },

    onEventDrop(info) {
      const ep = info.event.extendedProps;
        if (this.noarrastrarcitas) { info.revert(); return; }
      if (['GUARDIA','OCUPADO','BLOQUEADO','VACACIONES','RESERVA','RESUMEN','CONTADOR','FESTIVO_MES'].includes(ep.tipo)) { info.revert(); return; }
      this.cerrarop();
      if (this.overlayHideTimer) { clearTimeout(this.overlayHideTimer); this.overlayHideTimer = null; }
      this.guardarScroll();

      // Capturar datos ANTES de revertir
      const nuevoStart = info.event.start;
      const nuevoEnd   = info.event.end;
      const nuevoOperario = info.newResource?.id || info.event.getResources()[0]?.id || ep.id_operario;
      const recursoNuevo = info.newResource || info.event.getResources()[0];

      info.revert();
      this.difuminado = 'filter:blur(4px)';
      this.id_visita = ep.id_visita;
      this.comprobarIpas(ep.idservicio, ep.id_visita);
      this.eventoamodificar = {
        event: { title: info.event.title, start: nuevoStart, end: nuevoEnd, id_visita: ep.id_visita,
                 fecha_original: ep.fecha_original, fecha_fin_original: ep.fecha_fin_original },
        idservicio: ep.idservicio,
        originalStart: info.oldEvent.start,
        originalEnd:   info.oldEvent.end,
        newSplit: nuevoOperario,
        newDate: nuevoStart,
        nombreOperarioNuevo: info.newResource ? recursoNuevo?.title : '',
        originalEvent: { start: info.oldEvent.start, end: info.oldEvent.end },
      };
      this.tipoamodificar = 'arrastra';
      this.confirmacionvisible = true;
    },

    onEventResize(info) {
      const ep = info.event.extendedProps;
      if (['GUARDIA','OCUPADO','BLOQUEADO','VACACIONES','RESERVA','RESUMEN','CONTADOR','FESTIVO_MES'].includes(ep.tipo)) { info.revert(); return; }
      this.cerrarop();
      this.guardarScroll();

      const nuevoStart = info.event.start;
      const nuevoEnd   = info.event.end;

      info.revert();
      this.difuminado = 'filter:blur(4px)';
      this.id_visita = ep.id_visita;
      this.comprobarIpas(ep.idservicio, ep.id_visita);
      this.eventoamodificar = {
        event: { title: info.event.title, start: nuevoStart, end: nuevoEnd, id_visita: ep.id_visita },
        idservicio: ep.idservicio,
        originalStart: info.oldEvent.start,
        originalEnd:   info.oldEvent.end,
        originalEvent: { start: info.oldEvent.start, end: info.oldEvent.end },
        newSplit: info.event.getResources()[0]?.id,
        newDate: nuevoStart,
      };
      this.tipoamodificar = 'redimensiona';
      this.confirmacionvisible = true;
    },

    onHideConfirmacion() {
      this.confirmacionvisible = false;
      this.difuminado = '';
      this.recargar();
      this.restaurarScroll();
    },

    // ── Confirmar mover/redimensionar (servicio tomado de la propia cita) ──
    async crearevento(event, tipo) {
      const api = new PwgsApi();
      const idServ = event.idservicio || this.id;
      try {
        if (tipo === 'arrastra') {
          const segundos = (new Date(event.newDate).getTime() - new Date(event.originalStart).getTime()) / 1000;
          const sub = { id_operario: event.newSplit, tipo, segundos };
          this._agregarDatosIpas(sub);
          await api.put(`planning-pwgs/${idServ}/mover-visita/${event.event.id_visita}`, sub);
          this.$toast.add({ severity:'success', summary:'Guardado', detail:'Evento modificado correctamente', life:2000 });
        }
        if (tipo === 'redimensiona') {
          const segundos = (new Date(event.event.end).getTime() - new Date(event.originalEnd).getTime()) / 1000;
          const sub = { tipo, segundos };
          this._agregarDatosIpas(sub);
          await api.put(`planning-pwgs/${idServ}/mover-visita/${event.event.id_visita}`, sub);
          this.$toast.add({ severity:'success', summary:'Guardado', detail:'Evento redimensionado correctamente', life:2000 });
        }
        this.confirmacionvisible = false;   // el @hide ya recarga y quita el difuminado
      } catch (e) {
        this.$toast.add({ severity:'error', summary:'Error', detail:e, life:5000 });
      }
    },

    // ── IPAS: en el global no hay un servicio único → se consulta por la cita ──
    async comprobarIpas(idServicio, idVisita) {
      // Limpiar datos de un arrastre anterior para no reenviar una razón vieja
      this.ipas = false;
      this.razones = []; this.subrazones = [];
      this.razonipas = ''; this.subrazonipas = '';
      this.motivo = ''; this.cancelacion = '';
      this.valoresipas = [];
      this.idServicioIpas = idServicio || 0;
      if (!idServicio) return;
      const api = new PwgsApi();
      try {
        this.valoresipas = await api.post(`/planning-pwgs/${idServicio}/formulario-modifica-visita/${idVisita}`);
        for (const v of Object.values(this.valoresipas || {})) {
          if (v.nombre === 'razones_cancelacion_cita_mensaje') this.razones = Object.values(v.valores || {});
        }
        this.ipas = this.razones.length > 0;
      } catch (e) { console.log(e); }
    },

    async obtenersubrazones() {
      if (this.razonipas === '') { this.subrazones = []; return; }
      const api = new PwgsApi();
      try {
        const resp = await api.post(`/planning-pwgs/${this.idServicioIpas}/formulario-modifica-visita/${this.id_visita}`,
          { razones_cancelacion_cita_mensaje: this.razonipas });
        this.subrazones = [];
        let fecha = '', hora = '';
        for (const r of resp) {
          if (r.nombre === 'razones_cancelacion_cita_contrato_mensaje') this.subrazones = Object.values(r.valores);
          if (r.nombre === 'fecha_cancelacion_proximo_contacto_cita') fecha = r.valor;
          if (r.nombre === 'hora_cancelacion_proximo_contacto_confirmacion_cita') hora = r.valor;
        }
        if (fecha) this.cancelacion = this.convertirAFecha(`${fecha} ${hora}`);
      } catch (e) { console.log(e); }
    },

    async cargarPermisoEliminar() {
      try {
        this.permiteEliminarFinalizada = await this.comprobareliminarfinalizada();
      } catch (e) {
        this.permiteEliminarFinalizada = false;
      }
      // repintar por si el calendario ya se dibujó antes de la respuesta
      this.$refs.fullCalendar?.getApi()?.render();
    },

    puedeEliminarCita(finalizada, color) {
      const esFinalizada = String(finalizada) === '1' ||
                           String(color || '').toLowerCase() === '#e8eff4';
      return !esFinalizada || this.permiteEliminarFinalizada;
    },
    construirIndiceSemana(miseventos) {
      const especiales = ['GUARDIA','OCUPADO','BLOQUEADO','VACACIONES','RESERVA'];

      // Respetar el filtro de operarios seleccionados
      const sel = Array.isArray(this.operariosseleccionados) ? this.operariosseleccionados.map(String) : [];
      const filtrar = sel.length > 0;

      // Con guardia activa, limitar a los operarios visibles (los de guardia que trae la prop)
      const esGuardia = this.guardia === true;
      const idsVisibles = esGuardia
        ? new Set(Object.values(this.operarios || {}).map(op => String(op.idoperario)))
        : null;

      // Mapa id_operario → nombre
      const mapaOp = {};
      for (const op of Object.values(this.operarios || {})) {
        mapaOp[String(op.idoperario)] = op.nombre;
      }

      const idx = {};   // { 'YYYY-MM-DD': [ {operario, color, titulo, ...} ] }
      const push = (dia, item) => { (idx[dia] = idx[dia] || []).push(item); };

      for (const ev of (miseventos || [])) {
        if (filtrar && !sel.includes(String(ev.id_operario))) continue;
        if (idsVisibles && !idsVisibles.has(String(ev.id_operario))) continue;
        if (especiales.includes(ev.title)) continue;

        const startEvt = new Date(ev.start);
        const endEvt   = new Date(ev.end);
        if (isNaN(startEvt)) continue;

        const dia = `${startEvt.getFullYear()}-${String(startEvt.getMonth()+1).padStart(2,'0')}-${String(startEvt.getDate()).padStart(2,'0')}`;
        push(dia, {
          operario: mapaOp[String(ev.id_operario)] || '—',
          color: ev.color || '#ffe88c',
          titulo: this.decode_utf8(ev.poblacion || '') || 'Cita',
          horaIni: this.formatHora(startEvt),
          horaFin: this.formatHora(endEvt),
          idservicio: ev.id_servicio,
          referencia: ev.title || '',
          ts: startEvt.getTime(),
          tsFin: endEvt.getTime(),
          descripcion: this.decode_utf8(ev.description || ''),
          especialidad: this.decode_utf8(ev.especialidad || ''),
          direccion: this.decode_utf8(ev.direccion || ''),
          idVisita: ev.id,
          tieneFirma: ev.tiene_firma || '0',
          finalizada: ev.finalizada || '0',
        });
      }

      // Ordenar las citas de cada día por hora de inicio
      for (const dia of Object.keys(idx)) {
        idx[dia].sort((a, b) => a.ts - b.ts);
      }

      this._citasPorDia = idx;
    },
    onEventDidMount(info) {
      const tipo = info.event.extendedProps.tipo || info.event.title;
      if (tipo === 'VACACIONES' || tipo === 'BLOQUEADO') {
        info.el.style.pointerEvents = 'auto';   // los bg-events no reciben hover por defecto
      }
    },
    mostrarDia(dateStr, rect, jsEvent) {
      this.franjaTooltip = null;
      const citas = (this._citasPorDia && this._citasPorDia[dateStr]) || [];
      const festivo = this.buscarFestivo(dateStr);
      if (!citas.length && !festivo) return;

      this.citasDiaHover = citas;
      const f = new Date(dateStr + 'T00:00:00');
      let titulo = f.toLocaleDateString('es-ES', { weekday:'long', day:'2-digit', month:'2-digit' });
      if (festivo) titulo += festivo === 'Festivo' ? ' · Festivo' : ' · Festivo: ' + festivo;
      this.tituloDiaHover = titulo;

      // ── Posición: junto al ratón si hay evento; si no, bajo el elemento ──
      let x, y;
      if (jsEvent) {
        x = jsEvent.clientX + 12;
        y = jsEvent.clientY + 12;
      }
      else {
        x = rect.left;
        y = rect.bottom + 4;
      }

      // ── Ajuste al viewport ──
      const anchoTooltip = 330;                                    // maxWidth 320 + margen
      const altoTooltip  = Math.min(window.innerHeight * 0.6, 40 + citas.length * 24); // estimación (maxHeight 60vh)
      if (x + anchoTooltip > window.innerWidth) {
        x = (jsEvent ? jsEvent.clientX : rect.left) - anchoTooltip - 12;   // abrir hacia la izquierda
        if (x < 8) x = window.innerWidth - anchoTooltip - 8;
      }
      if (y + altoTooltip > window.innerHeight) {
        y = window.innerHeight - altoTooltip - 8;                  // subirlo para que quepa
      }
      if (y < 8) y = 8;
      if (x < 8) x = 8;
      this.overlayDiaX = x;
      this.overlayDiaY = y;
      if (this._diaHideTimer) { clearTimeout(this._diaHideTimer); this._diaHideTimer = null; }
      this.overlayDiaVisible = true;
      citas.forEach(c => { if (c.idVisita) this.cargarChatsVisita(c.idVisita); });
    },
    mostrarFranjaResumen(e, ep) {
      this.envioAbierto = null;
      this.subTooltipVisible = false;
      this.franjaTooltip = { ini: ep.franjaIni, dia: ep.dia };
      const franjaIni = ep.franjaIni;
      const franjaFin = ep.franjaFin;

      // Citas que solapan con la franja del bloque
      const todas = (this._citasPorDia && this._citasPorDia[ep.dia]) || [];
      const citas = todas.filter(c => c.ts < franjaFin && c.tsFin > franjaIni);
      if (!citas.length) { this.overlayDiaVisible = false; return; }

      this.citasDiaHover = citas;
      this.tituloDiaHover = '';

      // Posición junto al ratón + ajuste al viewport
      let x = e.clientX + 12, y = e.clientY + 12;
      const anchoTooltip = 330;
      const altoTooltip = Math.min(window.innerHeight * 0.6, 60 + citas.length * 44);
      if (x + anchoTooltip > window.innerWidth) {
        x = e.clientX - anchoTooltip - 12;
        if (x < 8) x = window.innerWidth - anchoTooltip - 8;
      }
      if (y + altoTooltip > window.innerHeight) y = window.innerHeight - altoTooltip - 8;
      if (y < 8) y = 8;
      if (x < 8) x = 8;
      this.overlayDiaX = x;
      this.overlayDiaY = y;

      if (this._diaHideTimer) { clearTimeout(this._diaHideTimer); this._diaHideTimer = null; }
      this._tooltipFestivo = false;
      this.overlayDiaVisible = true;
      citas.forEach(c => { if (c.idVisita) this.cargarChatsVisita(c.idVisita); });
    },
    mostrarSubTooltip(c, e) {
      if (!c.descripcion && !c.especialidad && !c.titulo) return;
      const rect = e.currentTarget.getBoundingClientRect();
      const ancho = 300;
      let x = rect.right + 8, y = rect.top;
      if (x + ancho > window.innerWidth) x = rect.left - ancho - 8;
      if (x < 8) x = 8;
      if (y + 150 > window.innerHeight) y = window.innerHeight - 158;
      if (y < 8) y = 8;
      let html = '';
      if (c.especialidad) html += `<b>${c.especialidad}</b><br>`;
      if (c.titulo) html += `${c.titulo}<br>`;
      html += c.descripcion || '';
      this.subTooltipHtml = html;
      this.subTooltipX = x;
      this.subTooltipY = y;
      this.subTooltipVisible = true;
    },

    ocultarSubTooltip() {
      this.subTooltipVisible = false;
    },
    marcarFestivoCelda(arg) {
      const d = arg.date;
      const dia = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
      return this.buscarFestivo(dia) ? ['pwgs-dia-festivo'] : [];
    },
    nuevaCitaDesdeFranja() {
      if (!this.franjaTooltip) return;
      this.overlayDiaVisible = false;
      const fecha = new Date(this.franjaTooltip.ini);
      this.abrirNuevaCita({
        date: fecha,
        resource: null,   // sin columna → abrirNuevaCita cae al primer operario
      });
    },
    async eliminarBloque() {
      const v = this.bloqueAEliminar;
      if (!v) return;
      const api = new PwgsApi();

      // Los bloqueos están en su propia tabla; las vacaciones son una visita
      let url;
      if (v.tipo === 'BLOQUEADO') {
        if (!v.id_bloqueo || !v.id_operario) {
          this.$toast.add({ severity:'error', summary:'Error', detail:'No se ha podido identificar el bloqueo', life:5000 });
          return;
        }
        url = `planning-pwgs/${v.id_operario}/eliminar-bloqueo/${v.id_bloqueo}`;
      } else {
        url = `planning-pwgs/${v.idservicio || this.id}/eliminar-visita/${v.id_visita}`;
      }

      try {
        await api.delete(url);
        this.$toast.add({ severity:'success', summary:'Eliminado',
          detail:(v.tipo === 'VACACIONES' ? 'Vacaciones eliminadas' : 'Bloqueo eliminado') + ' correctamente', life:2000 });
        this.bloqueConfirmar = false;
        this.recargar();
      }
      catch (e) {
        this.$toast.add({ severity:'error', summary:'Error', detail:e, life:5000 });
      }
    },
    cancelarEliminarBloque() {
      this.bloqueConfirmar = false;
    },
    iniciarCerrarDia() { this._diaHideTimer = setTimeout(() => { this.overlayDiaVisible = false; }, 250); },
    cancelarCerrarDia() { if (this._diaHideTimer) { clearTimeout(this._diaHideTimer); this._diaHideTimer = null; } },
    // ── Festivos ──────────────────────────────────────────────────────────────
    async cargarfestivos() {
      try {
        const api = new PwgsApi();
        const aux = await api.get(`festivos/${this.anyoactual}`);
        this.listadofestivos = aux.datos || [];
        this.comprobarfestivos();
        if (this._enMes) this.$refs.fullCalendar?.getApi()?.render();
      } catch (e) { console.log(e); }
    },

    comprobarfestivos() {
      const festivo = this.listadofestivos.find(f => {
        const fd = new Date(f.fecha);
        return fd.getFullYear() == this.anyoactual && fd.getMonth() + 1 == this.mesactual && fd.getDate() == this.diaactual;
      });
      this.nombrefestividad = festivo ? `Festivo ${festivo.nombre || ''}` : '';
      this.$nextTick(() => {
        const el = document.querySelector('.fc-toolbar-title');
        if (!el) return;
        el.querySelector('.pwgs-festivo-nombre')?.remove();
        el.style.background   = festivo ? '#28a745' : '';
        el.style.color        = festivo ? 'white'   : '';
        el.style.padding      = festivo ? '4px 8px' : '';
        el.style.borderRadius = festivo ? '4px'     : '';
        if (festivo && this._viewType === 'resourceTimeGridDay') {
          const span = document.createElement('span');
          span.className = 'pwgs-festivo-nombre';
          span.style.cssText = 'font-size:0.45em;margin-left:10px;vertical-align:middle;font-weight:600;';
          span.textContent = festivo.nombre ? `Festivo: ${festivo.nombre}` : 'Festivo';
          el.appendChild(span);
        }
      });
    },

    // ── datesSet: actualiza variables de fecha, NO recarga eventos ───────────
    onDatesSet(dateInfo) {
      const viewType = dateInfo.view.type;
      this.esVistaMes = viewType === 'dayGridMonth';
      this.esVistaDiaria = viewType === 'resourceTimeGridDay';
      if (this._viewType && this._viewType !== viewType) {
        this._viewType = viewType;
        const api = this.$refs.fullCalendar?.getApi();
        // Al entrar en mes O semana, vaciar eventos antes de cargar los nuevos
        if ((viewType === 'dayGridMonth' || viewType === 'timeGridWeek') && api) {
          api.removeAllEvents();
        }
        this.$nextTick(() => api?.refetchEvents());
      }
      else {
        this._viewType = viewType;
      }

      if (this.anyoactual !== this._lastYear) {
        this._lastYear = this.anyoactual;
        this.cargarfestivos();
      }
      else {
        this.comprobarfestivos();
      }
      // Comunicar al padre la fecha actual del calendario
      const f = dateInfo.view.currentStart;
      const fechaStr = `${f.getFullYear()}-${String(f.getMonth()+1).padStart(2,'0')}-${String(f.getDate()).padStart(2,'0')}`;
      this.$emit('fecha-actual', fechaStr);
  this.$nextTick(() => setTimeout(() => this.ponerMarcasDeAgua(), 300));
},

    mostrarFestivoDia(dateStr, rect) {
      this.franjaTooltip = null;
      const festivo = this.buscarFestivo(dateStr);
      if (!festivo) return;
      this.citasDiaHover = [];                                  // sin citas, solo el festivo
      this.tituloDiaHover = 'Festivo: ' + festivo;
      this.overlayDiaX = rect.left;
      this.overlayDiaY = rect.bottom + 4;                       // la cabecera está arriba, no hay problema de viewport
      if (this._diaHideTimer) { clearTimeout(this._diaHideTimer); this._diaHideTimer = null; }
      this._tooltipFestivo = true;
      this.overlayDiaVisible = true;
    },
    // ── Hover ─────────────────────────────────────────────────────────────────
    onEventMouseEnter(info) {
      const ep = info.event.extendedProps;
      const tipo = ep.tipo || info.event.title;
      const especiales = ['GUARDIA','OCUPADO','BLOQUEADO','VACACIONES','RESERVA','CONTADOR','FESTIVO_MES'];

      if (tipo === 'RESUMEN') {
        this.cancelarCerrarDia();
        this.mostrarFranjaResumen(info.jsEvent, ep);
        return;
      }

      if (tipo === 'VACACIONES' || tipo === 'BLOQUEADO') {
        this.descripcionbloq = ep.content || '';
        const rect = info.el.getBoundingClientRect();
        let bx = rect.right + 8, by = rect.top;
        const ancho = 360;
        if (bx + ancho > window.innerWidth) bx = rect.left - ancho - 8;
        if (bx < 8) bx = 8;
        this.overlayBloqX = bx;
        this.overlayBloqY = by;
        this.overlayBloqVisible = true;
        return;
      }
      if (especiales.includes(tipo)) return;

      this.eventoHover = info.event;
      this.nombreevento = tipo;
      this.distanciaevento = ep.distancia;
      this.colorkmevento = ep.color_km || '';
      this.descripcionevento = `Inicio: ${this.formatHora(info.event.start)} Fin: ${this.formatHora(info.event.end)}  ${this.decode_utf8(ep.content || '')}`;

      // Posicionar junto al evento, ajustado al viewport
      const rect = info.el.getBoundingClientRect();
      this._posicionarOverlay(rect.right + 8, rect.top + 10);

      // Mover con el ratón dentro del evento
      if (!this._mouseMoveHandler) {
        this._mouseMoveHandler = (e) => {
          this._posicionarOverlay(e.clientX + 15, e.clientY + 10);
        };
      }
      info.el.addEventListener('mousemove', this._mouseMoveHandler);

      if (this.overlayHideTimer) { clearTimeout(this.overlayHideTimer); this.overlayHideTimer = null; }
      this.overlayVisible = true;

      if (ep.idservicio) {
        this.cargarvisitaevento(ep.idservicio, ep.id_visita);
        this.comprobarChats(ep.id_visita);
      }
    },
    onEventMouseLeave(info) {
      if ((info.event.extendedProps.tipo) === 'RESUMEN') {
        this.iniciarCerrarDia();
        return;
      }
      if (this._mouseMoveHandler) {
        info.el.removeEventListener('mousemove', this._mouseMoveHandler);
      }
      this.iniciarCerrarOverlay();
      this.overlayBloqVisible = false;
    },

    iniciarCerrarOverlay() {
      this.overlayHideTimer = setTimeout(() => { this.overlayVisible = false; }, 300);
    },
    cancelarCerrarOverlay() {
      if (this.overlayHideTimer) { clearTimeout(this.overlayHideTimer); this.overlayHideTimer = null; }
    },
    // Orden alfabético con criterio español (ignora mayúsculas y acentos)
    ordenarAlfabeticamente(lista, campo) {
      return [...(lista || [])].sort((a, b) =>
        String(a?.[campo] ?? '').localeCompare(
          String(b?.[campo] ?? ''), 'es', { sensitivity: 'base', numeric: true }
        )
      );
    },
    accionCita(accion, c) {
      this.overlayDiaVisible = false;
      this.subTooltipVisible = false;
      this.envioAbierto = null;
      window.__fcGlobalBtnClick(accion, c.idVisita, c.idservicio);
    },
    toggleEnvios(i, e) {
      if (this.envioAbierto === i) { this.envioAbierto = null; return; }
      const rect = e.currentTarget.getBoundingClientRect();
      const altoMenu = 130;   // aprox. 4 items
      this.envioX = rect.left;
      this.envioY = (rect.top - altoMenu - 4 > 8) ? rect.top - altoMenu - 4 : rect.bottom + 4;
      this.envioAbierto = i;
    },
    cerrarop() { this.overlayVisible = false; this.overlayBloqVisible = false; },

    // ── Click evento ──────────────────────────────────────────────────────────
    onEventClick(info) {
      const ep = info.event.extendedProps;
      const tipo = ep.tipo || info.event.title;
      if (['GUARDIA','OCUPADO','BLOQUEADO','VACACIONES','RESERVA','CONTADOR','FESTIVO_MES','RESUMEN'].includes(tipo)) return;
      this.cerrarop();
      this.eventoamostrar = '';
      const s = info.event.start, e = info.event.end;
      this.titulo = `${tipo} || ${new Date(s).toLocaleDateString('es-ES')} ${this.formatHora(s)}-${this.formatHora(e)}`;
      this.infoevento = ep.content || '';
      this.trabajos = false;
      this.fechainicioeditar = s;
      this.fechafineditar = e;
      this.altura = '50vw';
      this.editar = false; this.finalizar = false;
      this.colorbotondos = 'normal'; this.colorboton = 'normal';
      this.colorbotontres = 'normal'; this.colorbotoncuatro = 'normal';
      this.guardarScroll();
      this.visible = true;
      this.cargarvisitaevento(ep.idservicio, ep.id_visita);
      this.comprobarChats(ep.id_visita);   
    },
    guardarScroll() {
      // No machacar una posición buena con un 0 sospechoso (cierre de diálogo en curso)
      if (window.scrollY === 0 && this._scrollY > 100) return;
      this._scrollY = window.scrollY;
      this._scrollers = Array.from(document.querySelectorAll('.fc-scroller')).map(el => ({ el, top: el.scrollTop, left: el.scrollLeft }));
    },
    restaurarScroll() {
      document.activeElement?.blur?.();
      this.$nextTick(() => setTimeout(() => {
        // Solo restaurar si el scroll se ha movido más de 50px de donde estaba
        if (Math.abs(window.scrollY - (this._scrollY || 0)) > 50) {
          window.scrollTo(0, this._scrollY || 0);
        }
        (this._scrollers || []).forEach(s => {
          if (document.body.contains(s.el) && Math.abs(s.el.scrollTop - s.top) > 50) {
            s.el.scrollTop = s.top;
            s.el.scrollLeft = s.left;
          }
        });
      }, 150));
    },
    async cargarContadorMes(anyo, mes) {
      const api = new PwgsApi();
      const eventos = [];

      // Al cambiar de mes se vacía la caché de detalle por día
      this._citasPorDia     = {};
      this._diasCargadosMes = {};

      // ── 1) Contadores del mes (activas / por confirmar / finalizadas) ──
      try {
        const datos = await api.get(`planning-pwgs/0/visitas-mes-dia?fecha=${parseInt(anyo)}-${parseInt(mes)}-01`);
        for (const [fecha, info] of Object.entries(datos || {})) {
          const dia = String(fecha).substring(0, 10);          // ya viene 'YYYY-MM-DD'
          if (!/^\d{4}-\d{2}-\d{2}$/.test(dia)) continue;      // sin new Date() → sin desfase de zona
          eventos.push({
            id: 'cont_' + dia,
            title: 'CONTADOR',
            start: dia,
            allDay: true,
            display: 'block',
            editable: false,
            classNames: ['CONTADOR'],
            extendedProps: {
              tipo: 'CONTADOR',
              activas:     Number(info.activas)     || 0,
              confirmar:   Number(info.confirmar)   || 0,
              finalizadas: Number(info.finalizadas) || 0,
            },
          });
        }
      }
      catch (e) { console.log(e); }

      // ── 2) Festivos del mes → badge "F" ──
      this._festivosPorDia = {};
      try {
        const festivos = await api.get(`festivos/${parseInt(anyo)}`);
        for (const f of (festivos.datos || [])) {
          const fd = new Date(f.fecha);
          if (fd.getMonth() + 1 == parseInt(mes)) {
            const dia = f.fecha.substring(0, 10);
            this._festivosPorDia[dia] = f.nombre || 'Festivo';
            eventos.push({
              id: 'fest_' + f.fecha,
              title: 'FESTIVO_MES',
              start: dia,
              allDay: true,
              display: 'block',
              editable: false,
              classNames: ['FESTIVO_MES'],
              extendedProps: { tipo: 'FESTIVO_MES', festivostitle: f.nombre },
            });
          }
        }
      }
      catch (e) { console.log(e); }

      return eventos;
    },
    // ── Carga las citas de UN día concreto (vista mensual, bajo demanda) ──
    async cargarCitasDelDia(dia) {
      const api = new PwgsApi();
      const especiales = ['GUARDIA','OCUPADO','BLOQUEADO','VACACIONES','RESERVA'];
      const cuerpo = {
        start: `${dia}T00:00:00`,
        end:   `${dia}T23:59:59`,
        id_servicio: 0,           // global
      };
      if (this.guardia === true || this.guardia === false) cuerpo.guardia = this.guardia;
      const citas = await api.post('planning-pwgs', cuerpo);

      // Mapa id_operario → nombre
      const mapaOp = {};
      for (const op of Object.values(this.operarios || {})) {
        mapaOp[String(op.idoperario)] = op.nombre;
      }

      // Filtro de operarios seleccionados (si no hay selección → todos)
      const sel = Array.isArray(this.operariosseleccionados) ? this.operariosseleccionados.map(String) : [];
      const filtrar = sel.length > 0;
      const lista = [];
      for (const ev of (citas || [])) {
        if (!ev.start) continue;
        if (especiales.includes(ev.title)) continue;
        if (filtrar && !sel.includes(String(ev.id_operario))) continue;

      const ini = new Date(ev.start);
      const fin = new Date(ev.end);
      if (isNaN(ini)) continue;
      lista.push({
        operario: mapaOp[String(ev.id_operario)] || ev.title || '—',
        color: ev.color || '#ffe88c',
        titulo: this.decode_utf8(ev.poblacion || '') || 'Cita',
        horaIni: this.formatHora(ini),
        horaFin: this.formatHora(fin),
        idservicio: ev.id_servicio,
        referencia: ev.title || '',
        ts: ini.getTime(),
        tsFin: fin.getTime(),
        descripcion: this.decode_utf8(ev.description || ''),
        especialidad: this.decode_utf8(ev.especialidad || ''),
        direccion: this.decode_utf8(ev.direccion || ''),
        idVisita: ev.id,
        tieneFirma: ev.tiene_firma || '0',
        finalizada: ev.finalizada || '0',
        });
      }
      lista.sort((a, b) => a.ts - b.ts);
      this._citasPorDia = this._citasPorDia || {};
      this._citasPorDia[dia] = lista;
      return lista;
    },

    // ── Clic simple en una casilla del mes → carga (si hace falta) y abre el tooltip ──
    async abrirDiaMes(dia, rect, jsEvent) {
      this._citasPorDia     = this._citasPorDia     || {};
      this._diasCargadosMes = this._diasCargadosMes || {};

      if (!this._diasCargadosMes[dia]) {
        try {
          await this.cargarCitasDelDia(dia);
          this._diasCargadosMes[dia] = true;
        } catch (e) {
        console.log(e);
        } finally {
          this.spinner = false;
        }
      }

      const hayCitas = (this._citasPorDia[dia] || []).length > 0;
      if (!hayCitas && !this.buscarFestivo(dia)) { this.overlayDiaVisible = false; return; }
      this.mostrarDia(dia, rect, jsEvent);
},
    iraservicio(idruta, codigo) {
      localStorage.setItem('nombreservicio' + idruta, codigo);
      this.$router.push('/servicios/' + idruta);
    },

    irAExpediente(c) {
      if (!c || !c.idservicio) return;
      this.overlayDiaVisible = false;
      this.iraservicio(c.idservicio, c.referencia || '');
    },
    convertir(fecha) {
      return fecha.toLocaleString('es-ES', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit', second:'2-digit' });
    },
    convertirAFecha(str) {
      const [fecha, hora] = str.split(' ');
      const [d, m, a] = fecha.split('/');
      const [h, min] = hora.split(':');
      return new Date(a, m - 1, d, h, min);
    },
    // ── Crear cita (desde el botón Nueva cita de la franja semanal) ──────────
    async abrirNuevaCita(info) {
      this.guardarScroll();
      this.cerrarop();
      this.nomodificar = '0';
      this.prioritaria = '0';
      this.equiposseleccionado = [];
      this.equiposanyadir = [];
      this.clientedescripcion = [];
      this.clienteseleccionado = '';
      this.especialidadesdos = [];

      // ¿Se abre desde la vista semanal?
      const esSemana = this.$refs.fullCalendar?.getApi()?.view?.type === 'timeGridWeek';

      // Operarios disponibles respetando el filtro del multiselect
      const sel = Array.isArray(this.operariosseleccionados) ? this.operariosseleccionados.map(String) : [];
      const filtrar = sel.length > 0;
      const opsFiltrados = Object.values(this.operarios || {})
        .filter(op => !filtrar || sel.includes(String(op.idoperario)));

      // Modo especialidad-primero: solo en semanal Y cuando no hay un único operario filtrado
      this.modoEspecialidadPrimero = esSemana && opsFiltrados.length !== 1;

      if (this.modoEspecialidadPrimero) {
        // SEMANAL sin filtro único: primero especialidad → todas las especialidades, sin operarios aún
        this.especialidadesdos = this.ordenarAlfabeticamente(Object.values(this.especialidades || {}), 'nombre');
        this.especialidadseleccionada = '';
        this.operariossplit = [];
        this.operarioseleccionado = '';
      } else {
        // DIARIA, o SEMANAL con un solo operario filtrado: flujo clásico (operario → sus especialidades)
        this.operariossplit = this.ordenarAlfabeticamente(
          opsFiltrados.map(op => ({ id: op.idoperario, label: op.nombre })), 'label'
        );
        this.operarioseleccionado = info.resource?.id || this.operariossplit[0]?.id || '';
      }

      await this.cargarequipos();
      // cargarpropiedades necesita un id de operario para el endpoint;
      // si aún no hay operario elegido (modo especialidad-primero) usamos el primero como id "técnico"
      const idParaPropiedades = this.operarioseleccionado || opsFiltrados[0]?.idoperario || '';
      await this.cargarpropiedades(idParaPropiedades, { date: info.date });
      if (!this.modoEspecialidadPrimero) await this.cargarespecialidadoperarios();
    },
    async cargarOperariosDeEspecialidad() {
      const idEsp = this.especialidadseleccionada;
      this.operariossplit = [];
      this.operarioseleccionado = '';
      if (!idEsp) return;

      const api = new PwgsApi();
      const sel = Array.isArray(this.operariosseleccionados) ? this.operariosseleccionados.map(String) : [];
      const filtrar = sel.length > 0;
      const ops = Object.values(this.operarios || {})
        .filter(op => !filtrar || sel.includes(String(op.idoperario)));

      // Caché de especialidades por operario para no repetir peticiones
      if (!this._espPorOperario) this._espPorOperario = {};
      const resultado = [];
      await Promise.all(ops.map(async op => {
        const id = op.idoperario;
        if (!this._espPorOperario[id]) {
          try { this._espPorOperario[id] = await api.get(`operarios/${id}/especialidades`); }
          catch (e) { this._espPorOperario[id] = {}; }
        }
        const esp = this._espPorOperario[id];
        const tiene = (esp.especificas?.datos || []).some(x => x.idespecialidad == idEsp) ||
                      (esp.no_especificas?.datos || []).some(x => x.idespecialidad == idEsp);
        if (tiene) resultado.push({ id, label: op.nombre, preferente: String(op.preferente_operario) === '1', carga: op.carga_operario });
      }));

      this.operariossplit = this.ordenarAlfabeticamente(resultado, 'label');
      this.operarioseleccionado = this.operariossplit[0]?.id || '';
    },
    onHideNuevaCita() {
      this._bloquearScroll();
      setTimeout(() => this._desbloquearScroll(), 150);
    },
    // ── Propiedades nueva visita ──────────────────────────────────────────────
    async cargarpropiedades(id, event) {
      this.trabajosserv = []; this.prestaciones = [];
      this.documentos = []; this.presupuestoss = []; this.grupos = [];
      this.medicion = '0';
      const api = new PwgsApi();
      this.descripcionvisitas = '';
      this.especialidadseleccionada = this.especioperarioseleccionado || '';
      this.prestacionseleccionada = ''; this.pedidosSeleccionados = '';
      this.trabajoservseleccionado = ''; this.telefonoseleccionado = '';

      // Redondeo a la franja de 15 min (coincide con snapDuration del calendario)
      const fechaaux = new Date(event.date);
      fechaaux.setMinutes(Math.floor(fechaaux.getMinutes() / 15) * 15, 0, 0);
      const auxMs = fechaaux;                  // sin +1h ni +30min
      const año = fechaaux.getFullYear();
      const mes = String(fechaaux.getMonth() + 1).padStart(2, '0');
      const dia = String(fechaaux.getDate()).padStart(2, '0');
      const hora = `${fechaaux.getHours()}:${String(fechaaux.getMinutes()).padStart(2,'0')}`;

      this.propiedadescalendariooper = await api.get(`planning-pwgs/${this.id}/formulario-visita/${id}?fecha=${año}-${mes}-${dia}&hora=${hora}`);

      const plantillas = this.propiedadescalendariooper?.plantillas_descripcion_visita || {};
      const keys = Object.keys(plantillas);
      if (keys.length === 1) { this.plantilladescripcionseleccionada = keys[0]; this.mostrarPlantillas = false; }
      else if (keys.length > 1) { this.mostrarPlantillas = true; }
      else { this.mostrarPlantillas = false; }

      this.nevisible = true;
      const dur = this.propiedadescalendariooper.duracion_defecto_tiempo_citas > 0 ? this.propiedadescalendariooper.duracion_defecto_tiempo_citas : 3600;
      this.id_reserva_visita = this.propiedadescalendariooper.id_visita || 0;
      this.eventoacrear = event.date;
      this.fechainicio = auxMs;
      this.fechafin = new Date(auxMs.getTime() + dur * 1000);

      this.pedidosactivado  = this.propiedadescalendariooper.mostrar?.pedidos === '1';
      this.equiposactivado  = this.propiedadescalendariooper.mostrar?.ids_equipos === '1';

      const datosOp = Object.values(this.propiedadescalendariooper.operarios_planning || {})[0] || {};
      this.porconfimaractivado = datosOp.mostrar?.confirmar_visita === '1';
      this.confirmar_cita = (this.porconfimaractivado && datosOp.confirmar_visita === '1') ? 1 : '';

      try {
        const d2 = await api.get(`clientes/${this.asegurado?.idcliente}`);
        this.direcciones = d2.datos[0]?.direcciones || [];
      } catch (e) { this.direcciones = []; }

      this.clientes = this.propiedadescalendariooper.clientes_servicio || [];
      for (const c of this.clientes) { this.clienteseleccionado = c; break; }
      for (const dir of Object.values(this.direcciones || {})) {
        const nc = { ...this.clienteseleccionado, direccion: dir.direccion, poblacion: dir.poblacion, provincia: dir.provincia, codigo_postal: dir.cp, id_secundaria: dir.id };
        nc.nombre = (nc.nombre || '') + ` (${dir.direccion})`;
        this.clientes.push(nc);
      }

      this.descripcionminima = this.propiedadescalendariooper.min_caracteres_descripcion_visita || 0;
      this.medicionactivada  = this.propiedadescalendariooper.mostrar?.medicion_cita === '1';


      this.trabajosservactivado = this.propiedadescalendariooper.mostrar?.trabajos_asignados === '1';
      if (this.trabajosservactivado) for (const dc of Object.values(this.propiedadescalendariooper.trabajos_asignados || {})) this.trabajosserv.push(dc);
      this.prestiacionesactivado = this.propiedadescalendariooper.mostrar?.prestaciones_ipas === '1';
      if (this.prestiacionesactivado) for (const dc of Object.values(this.propiedadescalendariooper.prestaciones_ipas || {})) this.prestaciones.push(dc);

      this.telefonosactivado = this.propiedadescalendariooper.mostrar?.telefonos_evento === '1';
      if (this.telefonosactivado) {
        const todos = this.gruposTelefonos.flatMap(grupo => grupo.telefonos);
        const marcado = todos.find(tlf => tlf.checked);
        this.telefonoseleccionado = (marcado || todos[0])?.id || null;
      }
      this.pedidos = this.propiedadescalendariooper.pedidos || [];
      this.documentosactivado = this.propiedadescalendariooper.mostrar?.visita_documentos === '1';
      if (this.documentosactivado) for (const dc of Object.values(this.propiedadescalendariooper.visita_documentos || {})) { dc.activated = dc.checked === 'checked' ? '1' : '0'; this.documentos.push(dc); }
      this.presupuestosactivado = this.propiedadescalendariooper.mostrar?.visita_presupuestos === '1';
      if (this.presupuestosactivado) for (const dc of Object.values(this.propiedadescalendariooper.visita_presupuestos || {})) { dc.activated = '1'; this.presupuestoss.push(dc); }
      this.gruposactivado = this.propiedadescalendario?.mostrar?.visita_grupos === '1';
      if (this.gruposactivado) for (const dc of Object.values(this.propiedadescalendario?.visita_grupos || {})) { dc.activated = dc.checked === 'checked' ? '1' : '0'; this.grupos.push(dc); }
    },

    // Especialidades: endpoint global (igual que el planning global antiguo)
    async cargarespecialidades() {
      const api = new PwgsApi();
      const datos = await api.get('especialidades');
      this.especialidades = datos.datos;
    },

    async cargarespecialidadoperarios() {
      if (!this.operarioseleccionado) return;
      const api = new PwgsApi();
      const esp = await api.get(`operarios/${this.operarioseleccionado}/especialidades`);
      const lista = [];
      for (const e of Object.values(this.especialidades || {})) {
        const enEsp   = (esp.especificas?.datos    || []).some(x => x.idespecialidad == e.id_especialidad);
        const enNoEsp = (esp.no_especificas?.datos || []).some(x => x.idespecialidad == e.id_especialidad);
        if (enEsp || enNoEsp) lista.push(e);
      }
      this.especialidadesdos = this.ordenarAlfabeticamente(lista, 'nombre');
    },

    async cargarequipos() {
      const api = new PwgsApi();
      try { this.equipos = await api.get(`servicios/${this.id}/equipos`); } catch (e) { this.equipos = []; }
    },

    agregarvisita() {
      if (this.descripcionvisitas.length < this.descripcionminima) { alert('La descripción no contiene los carácteres mínimos.'); return; }
      if (this.clienteseleccionado) {
        const sub = { cliente: this.clienteseleccionado.idcliente, descripcion: this.descripcionvisitas, nombre: this.clienteseleccionado.nombre };
        if (this.clienteseleccionado.id_secundaria) sub.id_secundaria = this.clienteseleccionado.id_secundaria;
        this.clientedescripcion.push(sub);
        this.clientesubir.push(this.clienteseleccionado);
        this.clientes = this.clientes.filter(c => c.idcliente !== this.clienteseleccionado.idcliente);
        this.clienteseleccionado = '';
      }
    },

    async nuevavisita(finicio, ffin) {
      const fLocal = d => new Date(d).toLocaleDateString('es-ES');
      const fh     = d => String(new Date(d).getHours()).padStart(2,'0');
      const fm     = d => String(new Date(d).getMinutes()).padStart(2,'0');
      if (this.clientedescripcion.length === 0) this.agregarvisita();
      if (this.clientedescripcion.length === 0) return;
      const clientes = this.clientedescripcion.map(cl => {
        const c = { id: cl.cliente, descripcion: cl.descripcion };
        if (cl.id_secundaria) c.id_secundaria = cl.id_secundaria;
        return c;
      });
      if (this.id_reserva_visita > 0) this.id_visita = this.id_reserva_visita;
      const subidadatos = {
        id_servicio: this.id,
        fecha_cita_inicio: fLocal(finicio), fecha_cita_fin: fLocal(ffin),
        hora_cita_inicio: `${fh(finicio)}:${fm(finicio)}:00`,
        hora_cita_fin:    `${fh(ffin)}:${fm(ffin)}:00`,
        reserva: 0, vacaciones: 0, clientes,
        id_prestacion_servicio: this.prestacionseleccionada,
        id_operario: this.operarioseleccionado,
        id_visita: this.id_visita,
        id_especialidad: this.especialidadseleccionada,
        medicion_cita: this.medicion,
        confirmar_cita: this.confirmar_cita,
        prioritaria_cita: this.prioritaria,
        no_modificar_cita: this.nomodificar,
        ids_equipos: this.equiposseleccionado,
        visita_documentos:   this.documentosactivado  ? this.documentos.filter(d => d.activated === '1').map(d => d.id)  : [],
        visita_grupos:       this.gruposactivado       ? this.grupos.filter(g => g.activated === '1').map(g => g.id)      : [],
        visita_presupuestos: this.presupuestosactivado ? this.presupuestoss.filter(p => p.activated === '1').map(p => p.id) : [],
        ids_pedidos: this.pedidosSeleccionados,
        telefono_evento: this.telefonoseleccionado || '',
      };
      const api = new PwgsApi();
      try {
        await api.post(`planning-pwgs/${this.id}/crear-visita`, subidadatos);
        this.$toast.add({ severity:'success', summary:'Enviado', detail:'Cita creada correctamente', life:2000 });
        this.nevisible = false;
        this.recargar();
      } catch (e) {
        this.$toast.add({ severity:'error', summary:'Error', detail:e, life:5000 });
        this.recargar();
      }
    },
    async modificarVisita(evento, fechini, fechfin, descr, modificar, prioritaria) {
      const fLocal = d => new Date(d).toLocaleDateString('es-ES');
      const fh     = d => String(new Date(d).getHours()).padStart(2,'0');
      const fm     = d => String(new Date(d).getMinutes()).padStart(2,'0');
      const sub = {
        fecha_cita_inicio: fLocal(fechini), fecha_cita_fin: fLocal(fechfin),
        hora_cita_inicio: `${fh(fechini)}:${fm(fechini)}:00`,
        hora_cita_fin:    `${fh(fechfin)}:${fm(fechfin)}:00`,
        descripcion_cita: descr, prioritaria_cita: prioritaria,
      };
      this._agregarDatosIpas(sub);
      const api = new PwgsApi();
      try {
        await api.put(`planning-pwgs/${evento.visita.servicios_idservicios || this.id}/modificar-visita/${evento.visita.idvisitador}`, sub);
        this.visible = false;
        this.$toast.add({ severity:'success', summary:'Guardado', detail:'Datos guardados correctamente', life:2000 });
      } catch (e) {
        this.$toast.add({ severity:'error', summary:'Error', detail:e, life:5000 });
        this.recargar();
      }
    },

    async finVisita() {
      const api = new PwgsApi();
      try {
        await api.put(`planning-pwgs/${this.eventoamostrar.visita.servicios_idservicios || this.id}/finalizar-visita/${this.eventoamostrar.visita.idvisitador}`,
          { trabajos_realizados_cita: this.trabajosrealizadostexto, trabajos_pendientes_cita: this.trabajospendientestexto });
        this.visible = false;
        this.recargar();
        this.$toast.add({ severity:'success', summary:'Guardado', detail:'Datos guardados correctamente', life:2000 });
      } catch (e) {
        this.$toast.add({ severity:'error', summary:'Error', detail:e, life:5000 });
      }
    },
    confirmarvisita(event) {
      this.citaconfirmar = true;
      this.datoscitaconfirmar = event;
      this.datoscitaconfirmar.fechacita    = new Date(`${event.visita.fecha}T${event.visita.hora}`);
      this.datoscitaconfirmar.fechacitafin = new Date(`${event.visita.fecha_fin}T${event.visita.hora_fin}`);
    },
    async aprobarconfirmar() {
      const fLocal = d => new Date(d).toLocaleDateString('es');
      const fTime  = d => new Date(d).toLocaleTimeString('es-ES', { hour:'2-digit', minute:'2-digit' });
      const api = new PwgsApi();
      try {
        await api.put(`planning-pwgs/${this.datoscitaconfirmar.visita.servicios_idservicios || this.id}/confirmar-visita/${this.datoscitaconfirmar.visita.idvisitador}`, {
          fecha_cita_inicio: fLocal(this.datoscitaconfirmar.fechacita),
          fecha_cita_fin:    fLocal(this.datoscitaconfirmar.fechacitafin),
          hora_cita_inicio:  fTime(this.datoscitaconfirmar.fechacita),
          hora_cita_fin:     fTime(this.datoscitaconfirmar.fechacitafin),
        });
        this.$toast.add({ severity:'success', summary:'Confirmada', detail:'Cita confirmada', life:2000 });
        this.citaconfirmar = false;
        this.recargar();
      } catch (e) {
        this.$toast.add({ severity:'error', summary:'Error', detail:e, life:5000 });
      }
    },

    _agregarDatosIpas(sub) {
      if (this.ipas && this.razones?.length > 0 && this.razonipas !== '') {
        sub.razones_cancelacion_cita_mensaje = this.razonipas;
        sub.motivo_cancelacion_cita = this.motivo;
        sub.razones_cancelacion_cita_contrato_mensaje = this.subrazonipas;
        if (this.cancelacion) {
          const f = this.convertir(this.cancelacion).split(', ')[0];
          const h = this.convertir(this.cancelacion).split(', ')[1];
          sub.fecha_cancelacion_proximo_contacto_cita = f;
          sub.hora_cancelacion_proximo_contacto_confirmacion_cita = h;
        }
        for (const v of Object.values(this.valoresipas)) {
          if (v.nombre === 'PROFESSION_NU_cancelacion_cita') sub.PROFESSION_NU_cancelacion_cita = v.valor;
          if (v.nombre === 'fecha_unix_visita_origen')       sub.fecha_unix_visita_origen = v.valor;
        }
      }
    },

    // ── Cargar visita detalle ─────────────────────────────────────────────────
    async cargarvisitaevento(idservicio, idevento) {
      if (!idservicio) return;
      const api = new PwgsApi();
      const key = `${idservicio}${idevento}`;
      this.cargandoOver = [key];
      try {
        const datos = await api.get(`servicios/${idservicio}/visitas`);
        if (this.cargandoOver.includes(key)) {
          for (const d of datos) {
            if (d.visita?.datos?.idvisitador == idevento) {
              this.eventoamostrar = d;
              this.operariosingular = d.visita.operarios_idoperario;
            }
          }
          this.cargandoOver = [];
        }
      } catch (e) { this.cargandoOver = []; }
    },

   async cargarChatsVisita(idvis) {
  if (!idvis) return 0;
  try {
    const api = new PwgsApi();
    const aux = await api.get(`chat-pwgs?id_visita=${idvis}`);
    const n = Number(aux?.n_total_registros) || 0;
    this.chatsPorVisita[idvis] = n;
    this._pintarBadgeChat(idvis, n);
    return n;
  } catch (e) {
    console.log(e);
    return 0;
  }
},
async comprobarChats(idvis) {
  this.chatsvisita = await this.cargarChatsVisita(idvis);
},
// Actualiza el punto rojo en el HTML generado de la cita (no es reactivo)
_pintarBadgeChat(idvis, n) {
  document.querySelectorAll(`[data-chat-badge="${idvis}"]`).forEach(el => {
    el.textContent = n;
    el.style.display = n > 0 ? 'inline-block' : 'none';
  });
},

    // ── Configuración general (horas del planning) — endpoint global ──────────
    async datosgenerales() {
      const api = new PwgsApi();
      this.propiedadescalendario = await api.get('planning-pwgs/0/formulario-visita');
       // Actualizar hora inicio y fin según configuración
            if (this.propiedadescalendario?.planning_hora_ini) {
                this.calendarOptions.slotMinTime = this.propiedadescalendario.planning_hora_ini + ':00:00';
                }
            if (this.propiedadescalendario?.planning_hora_fin) {
                this.calendarOptions.slotMaxTime = this.propiedadescalendario.planning_hora_fin + ':00:00';
            }
    },

    // ── Click en el título (fecha) → calendario emergente ────────────────────
    onClickTitulo(e) {
      const titulo = e.target.closest('.fc-toolbar-title');
      if (!titulo) return;
      e.stopPropagation();
      e.preventDefault();
      this.$refs.calenddos?.toggle(e, titulo);
    },
    _posicionarOverlay(x, y) {
  const anchoTooltip = 360;   // maxWidth 350 del .fc-overlay-panel + margen
  const altoTooltip = 220;    // estimación del panel de cita
  if (x + anchoTooltip > window.innerWidth) {
    x = x - anchoTooltip - 30;              // abrir hacia la izquierda del cursor
    if (x < 8) x = window.innerWidth - anchoTooltip - 8;
  }
  if (y + altoTooltip > window.innerHeight) {
    y = window.innerHeight - altoTooltip - 8;
  }
  if (y < 8) y = 8;
  if (x < 8) x = 8;
  this.overlayX = x;
  this.overlayY = y;
},
_vigilarSegundoDialogo() {
      // Cancela una vigilancia anterior si la hubiera
      if (this._observadorDialogo) { this._observadorDialogo.disconnect(); this._observadorDialogo = null; }

      this._segundoAbierto = false;

      // Si en 3s no ha aparecido ningún segundo diálogo (acciones sin diálogo), dejar de vigilar
      const timeoutMax = setTimeout(() => {
        if (this._observadorDialogo && !this._segundoAbierto) {
          this._observadorDialogo.disconnect();
          this._observadorDialogo = null;
        }
      }, 3000);

      const observer = new MutationObserver(() => {
        const n = document.querySelectorAll('.p-dialog').length;
        if (!this._segundoAbierto && n >= 2) {
          // El segundo diálogo acaba de entrar en el DOM → ocultar el detalle en este mismo frame
          this._segundoAbierto = true;
          this.detalleOculto = true;
        } else if (this._segundoAbierto && n < 2) {
          // El segundo diálogo se ha cerrado → cerrar también el detalle
          clearTimeout(timeoutMax);
          observer.disconnect();
          this._observadorDialogo = null;
          document.activeElement?.blur?.();
          this._bloquearScroll();
          this.detalleOculto = false;
          this.visible = false;
          setTimeout(() => this._desbloquearScroll(), 150);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      this._observadorDialogo = observer;
    },
    _textoContrasteKm(hex) {
      const h = String(hex).replace('#', '').trim();
      if (h.length !== 3 && h.length !== 6) return '#000';
      const full = h.length === 3 ? h.split('').map(x => x + x).join('') : h;
      const r = parseInt(full.substr(0, 2), 16);
      const g = parseInt(full.substr(2, 2), 16);
      const b = parseInt(full.substr(4, 2), 16);
      if ([r, g, b].some(v => Number.isNaN(v))) return '#000';
      // Luminancia percibida
      const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return lum > 0.6 ? '#000' : '#fff';
    },

    toggleTrabajos()       { this.trabajos = !this.trabajos; this.colorboton = this.trabajos ? 'green' : 'normal'; this._recalcAltura(); },
    toggleEditar()         { this.editar = !this.editar; this.colorbotondos = this.editar ? 'green' : 'normal'; this._recalcAltura(); },
    toggleComunicaciones() { this.mostrarcomunicaciones = !this.mostrarcomunicaciones; this.colorbotontres = this.mostrarcomunicaciones ? 'green' : 'normal'; this._recalcAltura(); },
    toggleFinalizar()      { this.finalizar = !this.finalizar; this.colorbotoncuatro = this.finalizar ? 'green' : 'normal'; },
    togglepresupuestos()   { this.presupuestos = !this.presupuestos; },
    _recalcAltura()        { this.altura = (this.trabajos || this.editar || this.mostrarcomunicaciones) ? '80vw' : '50vw'; },
  },
  computed: {
    numRecursos() {
      const sel = Array.isArray(this.operariosseleccionados) ? this.operariosseleccionados : [];
      if (sel.length > 0) return sel.length;
      return Object.values(this.operarios || {}).length;
    },
    anchoPlanning() {
      // Solo en vista diaria: cada operario ocupa como máximo un 25% del ancho
      if (!this.esVistaDiaria) return '100%';
      const n = this.numRecursos;
      if (!n || n >= 5) return '100%';
      return (n * 20) + '%';
    },
    estiloDistancia() {
      const c = (this.colorkmevento || '').trim();
      const base = { marginLeft: '6px', padding: '1px 6px', borderRadius: '3px', display: 'inline-block', fontWeight: 'bold' };
      if (!c) return { marginLeft: '6px' };
      return { ...base, backgroundColor: c, color: this._textoContrasteKm(c) };
    },
    gruposTelefonos() {
        const origen = this.propiedadescalendariooper?.telefonos_evento || {};

        return Object.values(origen).map(cliente => {
          const campos = Object.values(cliente).filter(dat => dat && dat.id);

          const telefonos = campos.map(dat => {
            const partes = String(dat.nombre || '').split(' - ');
            return {
              id: String(dat.id),
              numero: partes[0] || String(dat.id),
              descripcion: partes[2] || '',
              checked: dat.checked === 'checked',
            };
          });
          const nombre = String(campos[0]?.nombre || '').split(' - ')[1] || '';
          return { nombre: nombre, telefonos: telefonos };
        }).filter(grupo => grupo.telefonos.length > 0);
    },
  },
  watch: {
    razonipas() { this.obtenersubrazones(); },
    guardia()                { this.recargar(); },
    cambios()                { this.recargar(); },
    operariosseleccionados() { this.cargarRecursos(); this.recargar(); },
    operarios()              { this.cargarRecursos(); this.recargar(); },
    // Mismo prop que el planning global antiguo: fechacal (Date)
    fechacal(val)            { if (val) this.$refs.fullCalendar?.getApi()?.gotoDate(val); },
    operarioseleccionado() {
      if (this.modoEspecialidadPrimero) return;   // en semanal las especialidades no dependen del operario
      this.cargarespecialidadoperarios();
    },
    especioperarioseleccionado(val) { this.especialidadseleccionada = val; },
    plantilladescripcionseleccionada(val) {
      if (val && this.propiedadescalendariooper?.plantillas_descripcion_visita)
        this.descripcionvisitas = this.propiedadescalendariooper.plantillas_descripcion_visita[val];
    },
    especialidadseleccionada() { if (this.modoEspecialidadPrimero) this.cargarOperariosDeEspecialidad(); },
    anyoactual(v, o) { if (v !== o) this.cargarfestivos(); },
    fechacalddos(val) {
      if (!val) return;
        const api = this.$refs.fullCalendar?.getApi();
        if (api) {
          api.gotoDate(val);
        }
      this.$refs.calenddos?.hide();
    },
  },

  beforeUnmount() {
    if (this._marcasInterval) {
      clearInterval(this._marcasInterval);
      this._marcasInterval = null;
    }
    if (this._tituloClickHandler) {
      document.removeEventListener('click', this._tituloClickHandler, true);
      this._tituloClickHandler = null;
    }
    if (this._diaHoverHandler) {
      const cont = this.$refs.fullCalendar?.$el || document;
      cont.removeEventListener('mouseover', this._diaHoverHandler);
      if (this._diaOutHandler)   cont.removeEventListener('mouseout', this._diaOutHandler);
        this._diaHoverHandler = null;
        this._diaOutHandler = null;
      }
      if (this._diaHideTimer) { clearTimeout(this._diaHideTimer); this._diaHideTimer = null; }
      if (this._diaClickFueraHandler) {
        document.removeEventListener('click', this._diaClickFueraHandler);
        this._diaClickFueraHandler = null;
    }
    if (this._diaClickHandler) {
      const cont2 = this.$refs.fullCalendar?.$el || document;
      cont2.removeEventListener('click', this._diaClickHandler);
      this._diaClickHandler = null;
    }
    this._desbloquearScroll();
    if (this._observadorDialogo) { this._observadorDialogo.disconnect(); this._observadorDialogo = null; }
    if (this._scrollLockRaf) cancelAnimationFrame(this._scrollLockRaf);
  },

  mounted() {
    this._lastYear = String(new Date().getFullYear());
    this._viewType = 'resourceTimeGridDay';
    this._marcasInterval = null;

    // Inyectar CSS global en <head> — único método fiable para FullCalendar
    this.inyectarCSS();

    // sin dateClick: la nueva cita se crea desde el botón de la franja semanal)
    this.calendarOptions.datesSet             = this.onDatesSet;
    this.calendarOptions.eventClick           = this.onEventClick;
    this.calendarOptions.eventMouseEnter      = this.onEventMouseEnter;
    this.calendarOptions.eventMouseLeave      = this.onEventMouseLeave;
    this.calendarOptions.eventContent         = this.buildEventContent;
    this.calendarOptions.resourceLabelContent = this.buildResourceLabelContent;
    this.calendarOptions.resourceLabelClassNames = (arg) =>
      arg.resource.extendedProps.preferente == 1 ? ['col-preferente'] : [];
    this.calendarOptions.slotLabelContent     = this.buildSlotLabelContent;
    this.calendarOptions.events               = this.fetchEvents;
    this.calendarOptions.customButtons.compacto.click = this.toggleCompacto;
    this.calendarOptions.dayCellClassNames = this.marcarFestivoCelda;
    this.calendarOptions.dayHeaderClassNames = this.marcarFestivoCelda;
    this.calendarOptions.eventDidMount = this.onEventDidMount;
    this.calendarOptions.eventDragStart = this.onEventDragStart;
    this.calendarOptions.eventDrop      = this.onEventDrop;
    this.calendarOptions.eventResize    = this.onEventResize;
    // Handler global para botones dentro de eventos (onclick en HTML generado)
    window.__fcGlobalBtnClick = async (accion, idVisita, idServicio) => {
      // acción del botón del evento → método equivalente en visita_datos.vue
      const metodos = {
        irservicio:   'accederservicio',
        eliminar:     'eliminarvisita',
        confirmar:    'mostrarConfirmar',
        trabajos:     'mostrarTrabajos',
        presupuesto:  'mostrarpresupuestos',
        editar:       'mostrarEditar',
        finalizar:    'mostrarFinalizarBtn',
        fichaemail:   'parteoperarioemail',
        smsoperario:  'smsoperario',
        smsasegurado: 'smsasegurado',
        ste:          'steasegurado',
        parte:        'abrirventana',
        multi1:       'multi1',
        multi2:       'multi2',
        multi3:       'multi3',
        mapfre:       'mapf',
      };

    // Abrir el diálogo (monta visita_datos con sus datos)
    this.guardarScroll();
    await this.cargarvisitaevento(idServicio, idVisita);
    this.comprobarChats(idVisita);
    this.visible = true;
    await this.$nextTick();

    // El chat lo gestiona este componente (planningcomunicaciones)
    if (accion === 'chat') {
      if (!this.mostrarcomunicaciones) this.toggleComunicaciones();
      return;
    }
    const metodo = metodos[accion];
    if (!metodo) return;
    // Esperar a que el componente hijo esté montado dentro del diálogo
    let comp = null, intentos = 30;
    while (!comp && intentos-- > 0) {
      comp = this.$refs.visitaDatos;
      if (!comp) await new Promise(r => setTimeout(r, 50));
    }
    if (!comp || typeof comp[metodo] !== 'function') return;
    try { comp[metodo](); } catch (e) { console.log('Error al ejecutar', metodo, e); }

    // Si la acción abre un segundo diálogo, al cerrarse aquel se cierra también el de detalle
    this._vigilarSegundoDialogo();
  };
   window.__fcGlobalEliminarBloque = (idVisita, idServicio, tipo, idBloqueo, idOperario) => {
    this.bloqueAEliminar = {
      tipo,
      id_visita: idVisita,
      idservicio: idServicio,
      id_bloqueo: idBloqueo,
      id_operario: idOperario,
      content: this.descripcionbloq || '',
    };
    this.bloqueConfirmar = true;
  };
    // Toggle dropdown de envíos dentro del evento
    window.__fcGlobalToggleDropdown = (id) => {
      const el = document.getElementById(id);
      if (!el) return;
      const isOpen = el.style.display !== 'none';
      // cerrar todos
      document.querySelectorAll('[id^="ddg_"]').forEach(d => { d.style.display = 'none'; });
      if (!isOpen) el.style.display = 'block';
      // cerrar al hacer click fuera
      setTimeout(() => {
        const close = () => { el.style.display = 'none'; document.removeEventListener('click', close); };
        document.addEventListener('click', close);

      }, 0);
    };
    this.cargarRecursos();
    this.datosgenerales();
    this.cargarPermisoEliminar();
    this.cargarespecialidades();
    this.cargarfestivos();
    this.comprobarParametroArrastrar();
    this._tituloClickHandler = (e) => this.onClickTitulo(e);
    document.addEventListener('click', this._tituloClickHandler, true);
    this.$nextTick(() => setTimeout(() => this.ponerMarcasDeAgua(), 800));
    this._diaHoverHandler = (e) => {
      // Semana: hover en la cabecera del día → tooltip solo si es festivo
      if (this._viewType === 'timeGridWeek') {
        const th = e.target.closest('.fc-col-header-cell[data-date]');
        if (th) {
          const dia = th.getAttribute('data-date');
          if (this.buscarFestivo(dia)) {
            this.cancelarCerrarDia();
            this.mostrarFestivoDia(dia, th.getBoundingClientRect());
          }
        return;
        }
        if (this._tooltipFestivo && !e.target.closest('.fc-overlay-panel')) {
          this._tooltipFestivo = false;
          this.iniciarCerrarDia();
        }
      }
    // MES: ya no se abre por hover (ahora es por clic)
    };
    const cont = this.$refs.fullCalendar?.$el || document;
    cont.addEventListener('mouseover', this._diaHoverHandler);

    this._diaClickFueraHandler = (e) => {
      if (!this.overlayDiaVisible) return;
      if (e.target.closest('.fc-overlay-panel')) return;              // clic dentro del tooltip
      if (this._enMes && e.target.closest('.fc-daygrid-day[data-date]')) return; // lo gestiona el handler del mes
      this.overlayDiaVisible = false;
    };

    this._diaClickHandler = (e) => {
      // ── MES: 1 clic → tooltip del día · 2 clics → vista diaria ──
      if (this._enMes) {
        if (e.target.closest('.fc-overlay-panel')) return;
        const cell = e.target.closest('.fc-daygrid-day[data-date]');
        if (!cell) return;
        const dia   = cell.getAttribute('data-date');
        const ahora = Date.now();
        const api   = this.$refs.fullCalendar?.getApi();

        // Segundo clic sobre el mismo día → vista diaria
        if (this._ultimoClickMes && this._ultimoClickMes.clave === dia && (ahora - this._ultimoClickMes.t) < 400) {
          clearTimeout(this._timerClickMes);
          this._timerClickMes = null;
          this._ultimoClickMes = null;
          this.overlayDiaVisible = false;
          api?.changeView('resourceTimeGridDay', dia);
          return;
        }

        this._ultimoClickMes = { clave: dia, t: ahora };
        const rect    = cell.getBoundingClientRect();
        const jsEvent = { clientX: e.clientX, clientY: e.clientY };

        clearTimeout(this._timerClickMes);
          this._timerClickMes = setTimeout(() => {
          this._timerClickMes = null;
          this.abrirDiaMes(dia, rect, jsEvent);
        }, 260);   // margen para distinguir del doble clic
        return;
      }

      // Semanal: clic en la cabecera del día → vista diaria
      if (this._viewType !== 'timeGridWeek') return;
      const th = e.target.closest('.fc-col-header-cell[data-date]');
      if (!th) return;
      const api = this.$refs.fullCalendar?.getApi();
      if (!api) return;
      this.overlayDiaVisible = false;
      api.changeView('resourceTimeGridDay', th.getAttribute('data-date'));
    };
    cont.addEventListener('click', this._diaClickHandler);
    document.addEventListener('click', this._diaClickFueraHandler);
  },
};
</script>
<style>
.p-dialog.dialogo-oculto {
  visibility: hidden;
}
</style>
<style scoped>
.planning-fc-wrapper { position: relative; }
.spinner {
  width: 56px; height: 56px; border-radius: 50%;
  border: 9px solid #d9e3ff; border-right-color: #007bff;
  animation: sp 1s infinite linear;
  position: absolute; z-index: 30000; top: 20%; left: 50%; margin-left: -28px;
}
.fc-overlay-panel {
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
  padding: 8px 12px;
  max-width: 350px;
  font-size: 0.9em;
}

.tt-btn {
  background: #fffa; border: 1px solid #0002; border-radius: 3px;
  padding: 1px 4px; font-size: 0.7em; cursor: pointer; color: #333; line-height: 1.2;
}
.tt-dd { padding: 4px 10px; cursor: pointer; }
.tt-dd:hover { background: #f2f2f2; }

@keyframes sp { to { transform: rotate(1turn); } }
</style>